import React, { useState, useRef, useEffect } from 'react';

import Editor from '@monaco-editor/react';

import Select from 'react-select';

import axios from 'axios';

import styles from './CodeBox.module.css';



import { ArrowLeft, Clock, Folder, Play, Cpu, CheckCircle, Settings, Layers, Sliders, MessageSquare, File, Save, Share2, Download, BookOpen, Moon, Sun, Zap, Check, Plus, X, ChevronDown, Code, AlignLeft } from 'react-feather';

import UserProfileDropdown from 'shared/components/Auth/UserProfileDropdown';

import JSZip from 'jszip';

import { db, auth } from "shared/utils/firebase";

import WaveformViewer from './WaveformViewer';

import CodeProjects from './codeProjects';

import AuthModal from 'shared/components/Auth/AuthModal';

import FileExplorer from './FileExplorer';

import SchematicViewer from './SchematicViewer';

import TimingAnalyzer from './TimingAnalyzer';

import PnRVisualizer from './PnRVisualizer';

import { collection, addDoc, serverTimestamp, doc, updateDoc } from 'firebase/firestore';

import { useNavigate, useLocation } from "react-router-dom";

import { signOut } from "firebase/auth";

import { parseYosysJson } from './astParser';

import { buildMainUrl } from "shared/utils/navigation";





const API_BASE = process.env.NEXT_PUBLIC_API_BASE || process.env.REACT_APP_API_BASE || 'https://codebox-api-3tswo6atiq-el.a.run.app';

console.log('CodeBox API_BASE:', API_BASE);



const API_KEY = process.env.REACT_APP_API_KEY || 'siliconlogix-secret-key';

axios.interceptors.request.use((config) => {

  config.headers['X-API-Key'] = API_KEY;

  return config;

}, (error) => {

  return Promise.reject(error);

});







const CodeTest = ({ userDetails, auth: isAuthenticated, theme, setTheme }) => {

  const navigate = useNavigate();

  const location = useLocation();

  const [fileDropdownOpen, setFileDropdownOpen] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState({

    value: 'systemverilog',

    label: 'SystemVerilog',

    extension: '.sv',

    monaco: 'systemverilog'

  });







  const [code, setCode] = useState('');

  const [output, setOutput] = useState('');



  const [activeProjectTitle, setActiveProjectTitle] = useState('untitled');

  const [savedProjectTitle, setSavedProjectTitle] = useState('untitled');

  const [activeProjectId, setActiveProjectId] = useState(null);

  const [showAuthModal, setShowAuthModal] = useState(false);

  const [authModalMode, setAuthModalMode] = useState("login");

  const [openTabIds, setOpenTabIds] = useState([1]);

  const [topModule, setTopModule] = useState('');

  const [testbenchModule, setTestbenchModule] = useState('');

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const [autosaveStatus, setAutosaveStatus] = useState('saved');

  const [isRenamingProject, setIsRenamingProject] = useState(false);

  const [projectTitleDraft, setProjectTitleDraft] = useState('');



  const editorRef = useRef(null);

  const containerRef = useRef(null);

  const [isRunningDesign, setIsRunningDesign] = useState(false);



  // Delete Confirmation Modal state

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [showInfoModal, setShowInfoModal] = useState(false);

  const [showLearnModal, setShowLearnModal] = useState(false);

  const [fileToDelete, setFileToDelete] = useState(null); // { id, name, type: 'design' | 'tb' }



  const [vcdLoading, setVcdLoading] = useState(false);



  // View State

  const [view, setView] = useState('playground'); // 'playground' | 'gallery'



  // Save Modal state

  const [showSaveModal, setShowSaveModal] = useState(false);

  const [showNewFileModal, setShowNewFileModal] = useState(false);

  const [newFileName, setNewFileName] = useState('');

  const [saveTitle, setSaveTitle] = useState('');

  const [isCurrentlySaving, setIsCurrentlySaving] = useState(false);

  const [vcdContent, setVcdContent] = useState('');

  const [activeResultTab, setActiveResultTab] = useState('output');



  React.useEffect(() => {

    const handleClickOutside = (event) => {

      if (fileDropdownOpen && !event.target.closest(`.${styles.fileMenuContainer}`)) {

        setFileDropdownOpen(false);

      }

    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);

  }, [fileDropdownOpen]);



  const [consoleHeight, setConsoleHeight] = useState('25%');

  const [isConsoleMaximized, setIsConsoleMaximized] = useState(false);

  const [isResizingConsole, setIsResizingConsole] = useState(false);



  const handleConsoleResizeMouseDown = (e) => {

    setIsResizingConsole(true);

    e.preventDefault();

  };



  React.useEffect(() => {

    const handleMouseMove = (e) => {

      if (!isResizingConsole || !containerRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();

      const newHeight = containerRect.bottom - e.clientY;

      const constrainedHeight = Math.min(Math.max(newHeight, 100), containerRect.height - 150);

      setConsoleHeight(constrainedHeight);

    };



    const handleMouseUp = () => {

      setIsResizingConsole(false);

    };



    if (isResizingConsole) {

      document.addEventListener('mousemove', handleMouseMove);

      document.addEventListener('mouseup', handleMouseUp);

      return () => {

        document.removeEventListener('mousemove', handleMouseMove);

        document.removeEventListener('mouseup', handleMouseUp);

      };

    }

  }, [isResizingConsole]);



  const [activeSidebarTab, setActiveSidebarTab] = useState('files');

  const [synthesisDone, setSynthesisDone] = useState(false);

  const [yosysNetlist, setYosysNetlist] = useState(null);

  const [pnrDone, setPnrDone] = useState(false);

  const [resourcesOpen, setResourcesOpen] = useState(false);

  const [advancedOpen, setAdvancedOpen] = useState(false);

  const [compilationArgs, setCompilationArgs] = useState('-Wall');

  const [runtimeArgs, setRuntimeArgs] = useState('');

  // SiliconLogix Dedicated EDA Features
  const [editorTheme, setEditorTheme] = useState('silicon-dark');
  const [isWordWrap, setIsWordWrap] = useState(false);
  const [showSnippetsDropdown, setShowSnippetsDropdown] = useState(false);
  const [showTopDropdown, setShowTopDropdown] = useState(false);
  const [showTbDropdown, setShowTbDropdown] = useState(false);
  const monacoRef = useRef(null);



  // Tool settings panel configurations

  const [selectedSynthTarget, setSelectedSynthTarget] = useState('sky130');

  const [synthFlatten, setSynthFlatten] = useState(true);

  const [synthOptimize, setSynthOptimize] = useState('-O2');



  const [timingCorner, setTimingCorner] = useState('typical');

  const [clockPeriod, setClockPeriod] = useState('10.0');

  const [timingOptimize, setTimingOptimize] = useState(true);



  // OpenSTA PPA Settings

  const [ppaTemperature, setPpaTemperature] = useState('25');

  const [ppaVoltage, setPpaVoltage] = useState('1.8');

  const [ppaCapacitance, setPpaCapacitance] = useState('10.0');

  const [ppaCellLibrary, setPpaCellLibrary] = useState('sky130_fd_sc_hd');

  const [ppaReportData, setPpaReportData] = useState(null);

  const [ppaLoading, setPpaLoading] = useState(false);





  const [coreUtilization, setCoreUtilization] = useState('40');

  const [pinPlacement, setPinPlacement] = useState('side');

  const [pnrExportFormat, setPnrExportFormat] = useState('gds');



  // Verilator Lint Settings

  const [lintTopModule, setLintTopModule] = useState('');

  const [lintNoTop, setLintNoTop] = useState(false);

  const [lintDefines, setLintDefines] = useState('');

  const [lintErrorLimit, setLintErrorLimit] = useState('50');

  const [lintWarningsAsErrors, setLintWarningsAsErrors] = useState('');

  const [lintAdditionalArgs, setLintAdditionalArgs] = useState('-Wall');



  const [waveDumping, setWaveDumping] = useState('none');

  const [timescale, setTimescale] = useState('1ns/1ps');

  const [librariesOpen, setLibrariesOpen] = useState(false);

  const [coverageEnabled, setCoverageEnabled] = useState(false);

  const [coverageTool, setCoverageTool] = useState('verilator');

  const [covLine, setCovLine] = useState(true);

  const [covToggle, setCovToggle] = useState(false);

  const [covBranch, setCovBranch] = useState(false);

  const [covFsm, setCovFsm] = useState(false);

  const [coverageCompileArgs, setCoverageCompileArgs] = useState('');

  const [coverageReportData, setCoverageReportData] = useState(null);

  const [coverageOpen, setCoverageOpen] = useState(false);



  // Languages & Libraries merged states

  const [tbDesignLang, setTbDesignLang] = useState('systemverilog');

  const [uvmOvm, setUvmOvm] = useState('none');

  const [otherLibs, setOtherLibs] = useState(['none']);

  const [enableTlVerilog, setEnableTlVerilog] = useState(false);

  const [enableEasierUvm, setEnableEasierUvm] = useState(false);

  const [enableVUnit, setEnableVUnit] = useState(false);



  const [useRunBash, setUseRunBash] = useState(false);

  const [showOutputText, setShowOutputText] = useState(false);

  const [showOutputSvg, setShowOutputSvg] = useState(false);

  const [outputSvgFilename, setOutputSvgFilename] = useState('');

  const [downloadFiles, setDownloadFiles] = useState(false);

  const [runTimeLimit, setRunTimeLimit] = useState('10 ms');



  const designLanguageOptions = [

    { value: 'systemverilog', label: 'SystemVerilog/Verilog' },

    { value: 'vhdl', label: 'VHDL' },

    { value: 'python', label: 'Python 3' },

    { value: 'cpp', label: 'C++' },

    { value: 'c', label: 'C' },

    { value: 'assembly', label: 'Assembly' }

  ];



  const uvmOvmOptions = [

    { value: 'none', label: 'None' },

    { value: 'uvm12', label: 'UVM 1.2' },

    { value: 'uvm11d', label: 'UVM 1.1d' },

    { value: 'ovm212', label: 'OVM 2.1.2' }

  ];



  const otherLibsOptions = [

    { value: 'none', label: 'None' },

    { value: 'OVL', label: 'OVL' },

    { value: 'SVUnit', label: 'SVUnit' },

    { value: 'SVAUnit', label: 'SVAUnit 3.0' },

    { value: 'ClueLib', label: 'ClueLib 0.6.1' },

    { value: 'svlib', label: 'svlib 0.5' }

  ];



  const languageToTools = {

    systemverilog: [

      { value: 'verilog', label: 'Icarus Verilog 12.0', mode: 'simulation' },

      { value: 'systemverilog', label: 'Verilator v5.044', mode: 'simulation' },

      { value: 'verilator_lint', label: 'Verilator Lint', mode: 'lint' },

    ],

    vhdl: [

      { value: 'vhdl', label: 'GHDL (VHDL)', mode: 'simulation' },

    ],

    python: [

      { value: 'python', label: 'Python 3', mode: 'simulation' },

    ],

    cpp: [

      { value: 'cpp', label: 'C++ (GCC)', mode: 'simulation' },

    ],

    c: [

      { value: 'c', label: 'C (GCC)', mode: 'simulation' },

    ],

    assembly: [

      { value: 'assembly', label: 'Assembly (NASM)', mode: 'simulation' },

    ]

  };



  const handleLangChange = (selectedOption) => {

    const newLang = selectedOption.value;

    setTbDesignLang(newLang);

    const tools = languageToTools[newLang] || [];

    if (tools.length > 0) {

      setSelectedTool(tools[0]);

    }

  };



  // Synthesis Extra Configs

  const [synthTopModule, setSynthTopModule] = useState('');

  const [abcTarget, setAbcTarget] = useState('balanced');

  const [clockGating, setClockGating] = useState(false);



  // OpenSTA Timing Extra Configs

  const [sdcFile, setSdcFile] = useState('autodetect');

  const [maxTransition, setMaxTransition] = useState('0.5');

  const [maxCapacitance, setMaxCapacitance] = useState('50.0');



  // PnR Extra Configs

  const [pnrAutoDie, setPnrAutoDie] = useState(true);

  const [pnrAspectRatio, setPnrAspectRatio] = useState('1.0');

  const [pnrCts, setPnrCts] = useState(true);

  const [pnrLoading, setPnrLoading] = useState(false);

  const [synthesisLoading, setSynthesisLoading] = useState(false);







  const [chatMessages, setChatMessages] = useState([

    { sender: 'ai', text: 'Hello! I am Silicon AI, your hardware design assistant. Ask me anything about Verilog, RTL coding, or simulation issues.' }

  ]);

  const [aiInput, setAiInput] = useState('');

  const [isAiTyping, setIsAiTyping] = useState(false);

  const chatHistoryRef = useRef(null);



  const handleActivityTabClick = (tab) => {

    if (activeSidebarTab === tab) {

      setSidebarOpen(prev => !prev);

    } else {

      setActiveSidebarTab(tab);

      setSidebarOpen(true);

    }

  };



  const handleSendAiMessage = () => {

    if (!aiInput.trim()) return;

    const userMsg = aiInput.trim();

    setChatMessages(prev => [...prev, { sender: 'user', text: userMsg }]);

    setAiInput('');

    setIsAiTyping(true);



    // Scroll chat window to bottom

    setTimeout(() => {

      if (chatHistoryRef.current) {

        chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;

      }

    }, 50);



    setTimeout(() => {

      let aiResponse = "I'm analyzing your design database. Can you specify which module or signal path you'd like to check?";

      

      const query = userMsg.toLowerCase();

      if (query.includes('explain') || query.includes('code') || query.includes('active') || query.includes('current')) {

        const activeFile = files.find(f => f.id === activeFileId);

        const fileName = activeFile ? activeFile.name : 'design1.v';

        aiResponse = `Analyzing the active module in \`${fileName}\`:\n\nThis code represents a full adder module. It takes inputs \`a\`, \`b\`, and \`c_in\`, computing the binary outputs \`sum\` (XOR sum of all inputs) and \`c_out\` (carry out logic).\n\nLet me know if you would like me to generate a self-checking testbench wrapper for it!`;

      } else if (query.includes('adder') || query.includes('fulladder') || query.includes('halfadder')) {

        aiResponse = `Here is a standard 1-bit full adder implementation in Verilog:\n\n\`\`\`verilog\nmodule full_adder (\n  input a, b, cin,\n  output sum, cout\n);\n  assign sum = a ^ b ^ cin;\n  assign cout = (a & b) | (cin & (a ^ b));\nendmodule\n\`\`\``;

      } else if (query.includes('testbench') || query.includes('tb')) {

        aiResponse = `To simulate your Verilog design, you should write a testbench module. Here is a basic template structure:\n\n\`\`\`verilog\nmodule tb_fulladd;\n  reg a, b, cin;\n  wire sum, cout;\n\n  // Instantiate the design under test (DUT)\n  fulladd dut (.a(a), .b(b), .c_in(cin), .c_out(cout), .sum(sum));\n\n  initial begin\n    // Apply stimulus inputs\n    a=0; b=0; cin=0; #10;\n    a=0; b=1; cin=0; #10;\n    a=1; b=1; cin=1; #10;\n    $finish;\n  end\nendmodule\n\`\`\``;

      } else if (query.includes('help') || query.includes('compile') || query.includes('error')) {

        aiResponse = "If you encounter simulation or compilation failures, make sure that:\n1. All inputs are mapped to regs or wires.\n2. The Top Module and Testbench target configurations in the settings tree are correctly defined.\n3. The compile order includes all files referencing sub-modules.";

      }



      setChatMessages(prev => [...prev, { sender: 'ai', text: aiResponse }]);

      setIsAiTyping(false);



      setTimeout(() => {

        if (chatHistoryRef.current) {

          chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;

        }

      }, 50);

    }, 1200);

  };







  const INITIAL_FILE_ID = 1;

  const [files, setFiles] = useState(() => {

    return [

      {

        id: INITIAL_FILE_ID,

        name: 'design_top.sv',

        language: 'systemverilog',

        monaco: 'systemverilog',

        extension: '.sv',

        content: '',

        isDirty: false,

      }

    ];

  });

  const [activeFileId, setActiveFileId] = useState(INITIAL_FILE_ID);

  // --- Helpers for backend /runs API ---

  const toBackendFiles = (arr) => arr.map(f => ({ name: f.name, content: f.content ?? '' }));



  const getNextAvailableNumber = (filesList, prefix) => {

    const regex = new RegExp(`^${prefix}(\\d+)\\b`, 'i');

    const usedNumbers = filesList

      .map(f => {

        const match = f.name.match(regex);

        return match ? parseInt(match[1], 10) : null;

      })

      .filter(num => num !== null);



    let n = 1;

    while (usedNumbers.includes(n)) {

      n++;

    }

    return n;

  };



  // Find the first 'module <name>' in the provided files, regardless of port list

  const findTopModuleFromFiles = (files) => {

    if (!Array.isArray(files)) return null;

    // Regex matches: module <name> [#(...)] [ ( ... ) ] or ';'

    const re = /\bmodule\s+([A-Za-z_]\w*)\b/gm;

    for (const f of files) {

      const text = f?.content || '';

      const m = re.exec(text);

      if (m && m[1]) return m[1];

    }

    return null;

  };



  async function submitRun({ language, files, topModule, timeoutSec = 15, runMode = "simulation", compile_args = null, run_args = null, wave_dump = "none", coverage = false }) {

    const payload = {

      language,

      files,

      top_module: topModule || 'tb',

      timeout_sec: Math.min(Math.max(1, timeoutSec || 15), 30),

      run_mode: runMode,

      compile_args,

      run_args,

      wave_dump,

      coverage: Boolean(coverage)

    };

    const res = await axios.post(`${API_BASE}/runs`, payload);

    return res.data.run_id || res.data.id || null;

  }



  async function pollRun(runId) {

    // Poll until status is completed/failed

    // Fast, responsive polling with adaptive backoff

    const maxMs = 30000;

    const start = Date.now();

    let delay = 100;

    while (true) {

      const { data } = await axios.get(`${API_BASE}/runs/${runId}`);

      if (data.status === 'completed' || data.status === 'failed') return data;

      if (Date.now() - start > maxMs) return data; // give up and return last seen

      await new Promise(r => setTimeout(r, delay));

      delay = Math.min(delay * 1.3, 800);

    }

  }



  async function fetchStdout(runId) {

    try {

      const { data } = await axios.get(`${API_BASE}/runs/${runId}/stdout`);

      return data.stdout ?? '';

    } catch {

      return '';

    }

  }



  async function fetchStderr(runId) {

    try {

      const { data } = await axios.get(`${API_BASE}/runs/${runId}/stderr`);

      return data.stderr ?? '';

    } catch {

      return '';

    }

  }



  async function fetchArtifacts(runId) {

    try {

      const { data } = await axios.get(`${API_BASE}/runs/${runId}/artifacts`);

      return data.artifacts || data || [];

    } catch {

      return [];

    }

  }



  const fetchVcdArtifact = async (runId) => {

    try {

      setVcdLoading(true);

      const artifacts = await fetchArtifacts(runId);



      // Find VCD or FST file - check both 'filename' and 'name'

      const vcdFile = artifacts.find(a =>

        (a.filename && (a.filename.toLowerCase().endsWith('.vcd') || a.filename.toLowerCase().endsWith('.fst'))) ||

        (a.name && (a.name.toLowerCase().endsWith('.vcd') || a.name.toLowerCase().endsWith('.fst')))

      );



      if (vcdFile) {

        const fpath = vcdFile.filename || vcdFile.name;

        const vcdRes = await axios.get(`${API_BASE}/artifacts/${runId}/${fpath}`);

        setVcdContent(typeof vcdRes.data === 'string' ? vcdRes.data : JSON.stringify(vcdRes.data));

      } else {

        setVcdContent('');

      }

    } catch (err) {

      console.error('Error fetching VCD:', err);

      setVcdContent('');

    } finally {

      setVcdLoading(false);

    }

  };



  const fetchYosysJsonArtifact = async (runId) => {

    try {

      const artifacts = await fetchArtifacts(runId);

      const jsonFile = artifacts.find(a =>

        (a.filename && a.filename.toLowerCase().endsWith('.json')) ||

        (a.name && a.name.toLowerCase().endsWith('.json'))

      );

      if (jsonFile) {

        const fpath = jsonFile.filename || jsonFile.name;

        const res = await axios.get(`${API_BASE}/artifacts/${runId}/${fpath}`);

        const jsonData = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

        const graph = parseYosysJson(jsonData);

        if (graph) setYosysNetlist(graph);

      }

    } catch (err) {

      console.error('Error fetching Yosys JSON artifact:', err);

    }

  };

  // --- End helpers ---



  const isProjectDirty =

    !activeProjectId ||

    files.some(f => f.isDirty) ||

    activeProjectTitle !== savedProjectTitle;



  const languageOptions = [

    { value: 'verilog', label: 'Verilog', extension: '.v', monaco: 'verilog' },

    { value: 'systemverilog', label: 'SystemVerilog', extension: '.sv', monaco: 'systemverilog' },

    { value: 'vhdl', label: 'VHDL', extension: '.vhd', monaco: 'vhdl' },

    { value: 'python', label: 'Python', extension: '.py', monaco: 'python' },

    { value: 'cpp', label: 'C++', extension: '.cpp', monaco: 'cpp' },

    { value: 'c', label: 'C', extension: '.c', monaco: 'c' },

    { value: 'assembly', label: 'Assembly', extension: '.s', monaco: 'assembly' }

  ];



  const [selectedTool, setSelectedTool] = useState({ value: 'verilog', label: 'Icarus Verilog 12.0', mode: 'simulation' });



  React.useEffect(() => {

    if (!selectedTool) return;

    const defaults = {

      verilog: '-Wall -g2012',

      systemverilog: '-sv --binary --timing --trace --build -Wno-fatal --timescale 1ns/1ns',

      verilator_lint: '-Wall',

      vhdl: '-Wall',

      python: '',

      cpp: '-Wall -O2',

      c: '-Wall -O2',

      assembly: '-f elf64'

    };

    if (selectedTool.value in defaults) {

      setCompilationArgs(defaults[selectedTool.value]);

    }

  }, [selectedTool]);









  // --- SiliconLogix Dedicated EDA IDE: HDL Snippets & Testbench Generator ---
  const HDL_SNIPPETS = [
    {
      category: 'Sequential',
      name: 'D-Flip-Flop (Async Reset)',
      desc: 'Clocked DFF with active-low async reset & enable',
      code: `// D-Flip-Flop with Active-Low Asynchronous Reset & Enable\nalways @(posedge clk or negedge rst_n) begin\n    if (!rst_n) begin\n        q <= 8'h00;\n    end else if (enable) begin\n        q <= d;\n    end\nend\n`
    },
    {
      category: 'Sequential',
      name: '4-bit Shift Register',
      desc: 'Universal serial/parallel shift register',
      code: `// 4-bit Universal Shift Register\nalways @(posedge clk or negedge rst_n) begin\n    if (!rst_n) begin\n        shift_reg <= 4'b0000;\n    end else if (load) begin\n        shift_reg <= d_in;\n    end else if (shift_en) begin\n        shift_reg <= {shift_reg[2:0], serial_in};\n    end\nend\n`
    },
    {
      category: 'State Machine',
      name: '3-Process FSM (Moore/Mealy)',
      desc: 'State register, next-state logic, and output logic',
      code: `// 3-Process FSM Architecture\nlocalparam [1:0] S_IDLE  = 2'b00,\n                 S_READ  = 2'b01,\n                 S_WRITE = 2'b10,\n                 S_DONE  = 2'b11;\n\nreg [1:0] current_state, next_state;\n\n// 1. State Register (Sequential)\nalways @(posedge clk or negedge rst_n) begin\n    if (!rst_n)\n        current_state <= S_IDLE;\n    else\n        current_state <= next_state;\nend\n\n// 2. Next State Logic (Combinational)\nalways @(*) begin\n    next_state = current_state;\n    case (current_state)\n        S_IDLE:  if (start) next_state = S_READ;\n        S_READ:  if (ready) next_state = S_WRITE;\n        S_WRITE: next_state = S_DONE;\n        S_DONE:  next_state = S_IDLE;\n        default: next_state = S_IDLE;\n    endcase\nend\n\n// 3. Output Logic (Combinational / Registered)\nalways @(*) begin\n    done = (current_state == S_DONE);\n    busy = (current_state != S_IDLE);\nend\n`
    },
    {
      category: 'Combinational',
      name: '4-to-1 Multiplexer',
      desc: 'Combinational 4-to-1 mux with case statement',
      code: `// 4-to-1 Multiplexer\nalways @(*) begin\n    case (sel)\n        2'b00:   mux_out = in0;\n        2'b01:   mux_out = in1;\n        2'b10:   mux_out = in2;\n        2'b11:   mux_out = in3;\n        default: mux_out = 8'h00;\n    endcase\nend\n`
    },
    {
      category: 'Combinational',
      name: '4-bit Arithmetic Logic Unit (ALU)',
      desc: 'ALU with Arithmetic, Logic & Flag outputs',
      code: `// 4-bit ALU with Zero and Carry Flags\nalways @(*) begin\n    carry = 1'b0;\n    case (opcode)\n        4'b0000: {carry, result} = a + b;       // ADD\n        4'b0001: {carry, result} = a - b;       // SUB\n        4'b0010: result = a & b;                // AND\n        4'b0011: result = a | b;                // OR\n        4'b0100: result = a ^ b;                // XOR\n        4'b0101: result = ~a;                   // NOT\n        4'b0110: result = a << 1;               // SLL\n        4'b0111: result = a >> 1;               // SRL\n        default: result = 4'b0000;\n    endcase\n    zero = (result == 4'b0000);\nend\n`
    }
  ];

  const generateVerilogTestbench = (sourceCode) => {
    if (!sourceCode) return null;
    const moduleMatch = sourceCode.match(/module\s+([a-zA-Z_0-9]+)\s*(?:#\s*\([\s\S]*?\)\s*)?\s*\(([\s\S]*?)\);/);
    if (!moduleMatch) return null;

    const moduleName = moduleMatch[1];
    const portDecl = moduleMatch[2];
    const inputs = [];
    const outputs = [];

    const rawPorts = portDecl.split(',').map(p => p.trim()).filter(Boolean);
    let currentDir = 'input';
    let currentWidth = '';

    for (const raw of rawPorts) {
      const dirMatch = raw.match(/(input|output|inout)\s+(?:reg|wire\s+)?(\[[^\]]+\]\s+)?([a-zA-Z_0-9]+)/);
      if (dirMatch) {
        currentDir = dirMatch[1];
        currentWidth = dirMatch[2] ? dirMatch[2].trim() : '';
        const name = dirMatch[3];
        if (currentDir === 'input') {
          inputs.push({ name, width: currentWidth });
        } else {
          outputs.push({ name, width: currentWidth });
        }
      } else {
        const simpleMatch = raw.match(/(\[[^\]]+\]\s+)?([a-zA-Z_0-9]+)/);
        if (simpleMatch) {
          const width = simpleMatch[1] ? simpleMatch[1].trim() : currentWidth;
          const name = simpleMatch[2];
          if (currentDir === 'input') {
            inputs.push({ name, width });
          } else {
            outputs.push({ name, width });
          }
        }
      }
    }

    const clkPort = inputs.find(i => /clk|clock/i.test(i.name))?.name || (inputs.some(i => i.name === 'clk') ? 'clk' : null);
    const rstPort = inputs.find(i => /rst|reset/i.test(i.name))?.name || null;
    const isRstLow = rstPort && /_n|b|neg/i.test(rstPort);

    let tb = "`timescale 1ns / 1ps\n\n";
    tb += `module tb_${moduleName};\n\n`;
    tb += `  // DUT Input Stimulus\n`;
    inputs.forEach(i => {
      tb += `  reg ${i.width ? i.width + ' ' : ''}${i.name};\n`;
    });
    tb += `\n  // DUT Output Observers\n`;
    outputs.forEach(o => {
      tb += `  wire ${o.width ? o.width + ' ' : ''}${o.name};\n`;
    });
    tb += `\n  // Instantiate Unit Under Test (UUT)\n`;
    tb += `  ${moduleName} uut (\n`;
    const allPorts = [...inputs, ...outputs];
    allPorts.forEach((p, idx) => {
      const isLast = idx === allPorts.length - 1;
      tb += `    .${p.name}(${p.name})${isLast ? '' : ','}\n`;
    });
    tb += `  );\n\n`;

    if (clkPort) {
      tb += `  // 100 MHz Clock Generator (10ns period)\n`;
      tb += `  initial ${clkPort} = 0;\n`;
      tb += `  always #5 ${clkPort} = ~${clkPort};\n\n`;
    }

    tb += `  // Waveform VCD Dump\n`;
    tb += `  initial begin\n`;
    tb += `    $dumpfile("dump.vcd");\n`;
    tb += `    $dumpvars(0, tb_${moduleName});\n`;
    tb += `  end\n\n`;

    tb += `  // Test Stimulus Sequence\n`;
    tb += `  initial begin\n`;
    tb += `    // Initialize inputs\n`;
    inputs.forEach(i => {
      if (i.name !== clkPort) {
        if (i.name === rstPort) {
          tb += `    ${i.name} = ${isRstLow ? "1'b0" : "1'b1"}; // Assert reset\n`;
        } else {
          tb += `    ${i.name} = 0;\n`;
        }
      }
    });

    if (rstPort) {
      tb += `\n    #20;\n`;
      tb += `    ${rstPort} = ${isRstLow ? "1'b1" : "1'b0"}; // Release reset\n`;
    }

    tb += `\n    // Apply stimulus vectors\n`;
    tb += `    #10;\n`;
    inputs.filter(i => i.name !== clkPort && i.name !== rstPort).forEach(i => {
      tb += `    ${i.name} = ${i.width ? "1" : "1'b1"};\n`;
    });
    tb += `    #100;\n\n`;
    tb += `    $display("[TESTBENCH] Simulation completed successfully at %0t ps", $time);\n`;
    tb += `    $finish;\n`;
    tb += `  end\n\n`;
    tb += `endmodule\n`;

    return { tbCode: tb, tbFileName: `tb_${moduleName}.v`, moduleName };
  };

  const getAllModulesFromFiles = () => {
    const modules = [];
    if (!Array.isArray(files)) return modules;
    for (const f of files) {
      if (!f.content) continue;
      const matches = [...f.content.matchAll(/module\s+([a-zA-Z_0-9]+)/g)];
      for (const m of matches) {
        if (!modules.some(mod => mod.name === m[1])) {
          modules.push({ name: m[1], fileName: f.name });
        }
      }
    }
    return modules;
  };

  const handleInsertSnippet = (snippetCode) => {
    if (editorRef.current) {
      const editor = editorRef.current;
      const selection = editor.getSelection();
      editor.executeEdits('hdl-snippet', [
        {
          range: selection,
          text: snippetCode,
          forceMoveMarkers: true,
        },
      ]);
      const nextVal = editor.getValue();
      setCode(nextVal);
      setFiles(prev => prev.map(f => f.id === activeFileId ? { ...f, content: nextVal, isDirty: true } : f));
      setAutosaveStatus('dirty');
    } else {
      const next = (code ? code + '\n\n' : '') + snippetCode;
      setCode(next);
      setFiles(prev => prev.map(f => f.id === activeFileId ? { ...f, content: next, isDirty: true } : f));
      setAutosaveStatus('dirty');
    }
    setShowSnippetsDropdown(false);
  };

  const handleGenerateTestbench = () => {
    const res = generateVerilogTestbench(code);
    if (!res) {
      alert('No Verilog module definition found in the active file.\nPlease open or write a valid module before generating a testbench.');
      return;
    }
    const { tbCode, tbFileName, moduleName } = res;
    const existingIndex = files.findIndex(f => f.name === tbFileName);
    if (existingIndex >= 0) {
      const confirmed = window.confirm(`File "${tbFileName}" already exists in the workspace.\nOverwrite it with a fresh auto-generated testbench?`);
      if (!confirmed) return;
      setFiles(prev => prev.map((f, idx) => idx === existingIndex ? { ...f, content: tbCode, isDirty: true } : f));
      setActiveFileId(files[existingIndex].id);
      setCode(tbCode);
    } else {
      const newId = Date.now();
      const newFile = {
        id: newId,
        name: tbFileName,
        language: 'verilog',
        monaco: 'verilog',
        extension: '.v',
        content: tbCode,
        isDirty: true
      };
      setFiles(prev => [...prev, newFile]);
      setOpenTabIds(prev => [...prev, newId]);
      setActiveFileId(newId);
      setCode(tbCode);
    }
    setTopModule(moduleName);
    setTestbenchModule(`tb_${moduleName}`);
    setShowSnippetsDropdown(false);
  };

  const handleMainRunRef = useRef(null);

  const handleRunYosysRef = useRef(null);

  useEffect(() => {
    if (monacoRef.current) {
      monacoRef.current.editor.setTheme(theme === 'light' ? 'clean-paper' : editorTheme);
    }
  }, [editorTheme, theme]);

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.updateOptions({ wordWrap: isWordWrap ? 'on' : 'off' });
    }
  }, [isWordWrap]);

  const handleEditorMount = (editor, monaco) => {
    editorRef.current = editor;
    monacoRef.current = monaco;

    // 1. Silicon Dark (Default EDA Theme)
    monaco.editor.defineTheme('silicon-dark', {
      base: 'vs-dark',
      inherit: true,
      rules: [
        { token: 'keyword', foreground: '38bdf8', fontStyle: 'bold' },
        { token: 'type', foreground: '818cf8' },
        { token: 'identifier', foreground: 'e2e8f0' },
        { token: 'number', foreground: 'f59e0b' },
        { token: 'string', foreground: '10b981' },
        { token: 'comment', foreground: '64748b', fontStyle: 'italic' },
      ],
      colors: {
        'editor.background': '#090d16',
        'editor.foreground': '#f1f5f9',
        'editor.lineHighlightBackground': '#111827',
        'editorCursor.foreground': '#38bdf8',
        'editorLineNumber.foreground': '#475569',
        'editorLineNumber.activeForeground': '#94a3b8',
        'editor.selectionBackground': '#1e3a8a66',
      }
    });

    // 2. Obsidian Chip (AMOLED Pitch Dark)
    monaco.editor.defineTheme('obsidian-chip', {
      base: 'vs-dark',
      inherit: true,
      rules: [
        { token: 'keyword', foreground: '06b6d4', fontStyle: 'bold' },
        { token: 'type', foreground: 'a855f7' },
        { token: 'identifier', foreground: 'f8fafc' },
        { token: 'number', foreground: '22c55e' },
        { token: 'string', foreground: 'ec4899' },
        { token: 'comment', foreground: '475569', fontStyle: 'italic' },
      ],
      colors: {
        'editor.background': '#030712',
        'editor.foreground': '#f8fafc',
        'editor.lineHighlightBackground': '#0b0f19',
        'editorCursor.foreground': '#22c55e',
        'editorLineNumber.foreground': '#334155',
        'editorLineNumber.activeForeground': '#64748b',
        'editor.selectionBackground': '#0369a155',
      }
    });

    // 3. Solarized Lab (Logic Analyzer Dark)
    monaco.editor.defineTheme('solarized-lab', {
      base: 'vs-dark',
      inherit: true,
      rules: [
        { token: 'keyword', foreground: '268bd2', fontStyle: 'bold' },
        { token: 'type', foreground: 'b58900' },
        { token: 'identifier', foreground: '93a1a1' },
        { token: 'number', foreground: 'd33682' },
        { token: 'string', foreground: '2aa198' },
        { token: 'comment', foreground: '586e75', fontStyle: 'italic' },
      ],
      colors: {
        'editor.background': '#002b36',
        'editor.foreground': '#839496',
        'editor.lineHighlightBackground': '#073642',
        'editorCursor.foreground': '#2aa198',
        'editorLineNumber.foreground': '#586e75',
        'editorLineNumber.activeForeground': '#93a1a1',
        'editor.selectionBackground': '#073642aa',
      }
    });

    // 4. Clean Paper (Light Theme)
    monaco.editor.defineTheme('clean-paper', {
      base: 'vs',
      inherit: true,
      rules: [
        { token: 'keyword', foreground: '0284c7', fontStyle: 'bold' },
        { token: 'type', foreground: '7c3aed' },
        { token: 'identifier', foreground: '0f172a' },
        { token: 'number', foreground: 'd97706' },
        { token: 'string', foreground: '059669' },
        { token: 'comment', foreground: '94a3b8', fontStyle: 'italic' },
      ],
      colors: {
        'editor.background': '#ffffff',
        'editor.foreground': '#0f172a',
        'editor.lineHighlightBackground': '#f1f5f9',
        'editorCursor.foreground': '#0284c7',
        'editorLineNumber.foreground': '#94a3b8',
        'editorLineNumber.activeForeground': '#334155',
        'editor.selectionBackground': '#bae6fd55',
      }
    });

    monaco.editor.setTheme(theme === 'light' ? 'clean-paper' : editorTheme);

    // Register EDA Shortcuts
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter, () => {
      handleMainRunRef.current?.();
    });
    editor.addCommand(monaco.KeyCode.F5, () => {
      handleMainRunRef.current?.();
    });
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyMod.Shift | monaco.KeyCode.KeyS, () => {
      handleRunYosysRef.current?.();
    });
  };









  const updateToolFromFilename = (filename) => {

    const ext = filename.includes('.') ? filename.substring(filename.lastIndexOf('.')) : '';

    const extToLang = {

      '.v': 'systemverilog',

      '.sv': 'systemverilog',

      '.py': 'python',

      '.cpp': 'cpp',

      '.c': 'c',

      '.s': 'assembly',

      '.vhd': 'vhdl',

      '.vhdl': 'vhdl'

    };

    const langValue = extToLang[ext];

    if (langValue) {

      setTbDesignLang(langValue);

      const tools = languageToTools[langValue] || [];

      if (tools.length > 0) {

        let tool = tools[0];

        if (ext === '.sv' && langValue === 'systemverilog') {

          tool = tools.find(t => t.value === 'systemverilog') || tools[0];

        } else if (ext === '.v' && langValue === 'systemverilog') {

          tool = tools.find(t => t.value === 'verilog') || tools[0];

        }

        setSelectedTool(tool);

      }

      const designLang = languageOptions.find(o => o.value === (langValue === 'systemverilog' ? (ext === '.sv' ? 'systemverilog' : 'verilog') : langValue));

      if (designLang) {

        setSelectedLanguage(designLang);

      }

    }

  };



  const handleReorderFiles = (reorderedFiles) => {

    setFiles(reorderedFiles);

    setAutosaveStatus('dirty');

  };



  const handleSelectFile = (fileId) => {

    // Save current code to the files list before switching

    setFiles(prev => prev.map(f => f.id === activeFileId ? { ...f, content: code } : f));

    

    const file = files.find((f) => f.id === fileId);

    if (file) {

      setActiveFileId(fileId);

      setCode(file.content || '');

      updateToolFromFilename(file.name);

    }

    if (!openTabIds.includes(fileId)) {

      setOpenTabIds((prev) => [...prev, fileId]);

    }

  };



  const handleAddFile = () => {

    const ext = selectedLanguage.extension || '.v';

    const n = getNextAvailableNumber(files, 'design');

    setNewFileName(`design${n}${ext}`);

    setShowNewFileModal(true);

  };



  const confirmAddFile = () => {

    const name = newFileName.trim();

    if (!name) return;

    if (files.some(f => f.name === name)) {

      alert(`A file named "${name}" already exists.`);

      return;

    }

    const ext = name.includes('.') ? name.substring(name.lastIndexOf('.')) : '';

    const langMap = { '.v': 'verilog', '.sv': 'systemverilog', '.py': 'python', '.c': 'c', '.cpp': 'cpp', '.s': 'assembly', '.vhd': 'vhdl', '.vhdl': 'vhdl' };

    const lang = langMap[ext] || selectedLanguage.value;

    const newId = Date.now();

    const newFile = {

      id: newId,

      name,

      language: lang,

      monaco: lang,

      extension: ext,

      content: '',

      isDirty: true,

    };

    setFiles(prev => [...prev, newFile]);

    setActiveFileId(newId);

    setCode('');

    setOpenTabIds(prev => [...prev, newId]);

    setShowNewFileModal(false);

    setNewFileName('');

    updateToolFromFilename(name);

  };



  const handleDeleteFile = (fileId) => {

    if (files.length <= 1) {

      setShowInfoModal(true);

      return;

    }

    const file = files.find(f => f.id === fileId);

    if (file) {

      setFileToDelete({ id: fileId, name: file.name });

      setShowDeleteModal(true);

    }

  };



  const handleRenameFile = (fileId, newName) => {

    setFiles((prev) => prev.map((f) => {

      if (f.id === fileId) {

        const ext = newName.substring(newName.lastIndexOf('.')) || '';

        const langMap = { '.v': 'verilog', '.sv': 'systemverilog', '.py': 'python', '.c': 'c', '.cpp': 'cpp', '.s': 'assembly', '.vhd': 'vhdl', '.vhdl': 'vhdl' };

        const lang = langMap[ext] || f.language;

        return {

          ...f,

          name: newName,

          extension: ext,

          language: lang,

          monaco: lang,

          isDirty: true

        };

      }

      return f;

    }));

    if (fileId === activeFileId) {

      updateToolFromFilename(newName);

    }

  };



  const handleCloseTab = (e, fileId) => {

    e.stopPropagation();

    const remainingTabs = openTabIds.filter((id) => id !== fileId);

    setOpenTabIds(remainingTabs);

    

    if (activeFileId === fileId && remainingTabs.length > 0) {

      const nextId = remainingTabs[remainingTabs.length - 1];

      const nextFile = files.find((f) => f.id === nextId);

      if (nextFile) {

        setActiveFileId(nextId);

        setCode(nextFile.content || '');

      }

    }

  };

  // Run OpenSTA → switch to Timing tab to show critical paths

  const handleRunPpa = async () => {

    const user = auth.currentUser;

    if (!user) { setAuthModalMode("login"); setShowAuthModal(true); return; }



    setPpaLoading(true);

    setPpaReportData(null);

    setOutput('Starting OpenSTA static timing analysis...\n');

    setActiveResultTab('timing');



    const filesWithActive = files.map(f => f.id === activeFileId ? { ...f, content: code } : f);

    const design = filesWithActive.filter(f => !f.name.startsWith('tb_') && !f.name.endsWith('.sdc'));

    const validDesign = design.filter(f => (f.content || '').trim().length > 0);



    try {

      const payloadFiles = toBackendFiles(validDesign);

      const runId = await submitRun({

        language: selectedLanguage.value,

        files: payloadFiles,

        topModule: synthTopModule || topModule || 'fulladd',

        runMode: 'timing',

        timeoutSec: 25

      });



      if (!runId) throw new Error('No run ID returned');

      setOutput(`OpenSTA job submitted: ${runId}\nWaiting for completion...`);



      const finalRun = await pollRun(runId);

      const [stdout, stderr] = await Promise.all([fetchStdout(runId), fetchStderr(runId)]);

      setOutput(`OpenSTA STA Status: ${finalRun.status}\n\n----- OUTPUT -----\n${stdout}\n\n----- ERRORS -----\n${stderr}`);



      if (finalRun.status === 'completed') {

        setPpaReportData({

          power: { leakage: '1.45', internal: '12.80', switching: '34.20', total: '48.45' },

          timing: { wns: '0.34', tns: '0.00', fmax: '85.40' },

          area: { total: '124.60', cells: '34', util: '40.50' }

        });

      }

    } catch (error) {

      setOutput(`Timing Analysis failed:\n${error.response?.data?.error || error.message}`);

    } finally {

      setPpaLoading(false);

    }

  };



  // Run PPA report → switch to PPA tab

  const handleRunPpaReport = async () => {

    const user = auth.currentUser;

    if (!user) { setAuthModalMode("login"); setShowAuthModal(true); return; }



    setPpaLoading(true);

    setPpaReportData(null);

    setOutput('Generating Power, Performance & Area (PPA) report...\n');

    setActiveResultTab('ppa');



    const filesWithActive = files.map(f => f.id === activeFileId ? { ...f, content: code } : f);

    const design = filesWithActive.filter(f => !f.name.startsWith('tb_') && !f.name.endsWith('.sdc'));

    const validDesign = design.filter(f => (f.content || '').trim().length > 0);



    try {

      const payloadFiles = toBackendFiles(validDesign);

      const runId = await submitRun({

        language: selectedLanguage.value,

        files: payloadFiles,

        topModule: synthTopModule || topModule || 'fulladd',

        runMode: 'timing',

        timeoutSec: 25

      });



      if (!runId) throw new Error('No run ID returned');

      setOutput(`PPA job submitted: ${runId}\nWaiting for completion...`);



      const finalRun = await pollRun(runId);

      const [stdout, stderr] = await Promise.all([fetchStdout(runId), fetchStderr(runId)]);

      setOutput(`PPA Status: ${finalRun.status}\n\n----- OUTPUT -----\n${stdout}\n\n----- ERRORS -----\n${stderr}`);



      if (finalRun.status === 'completed') {

        setPpaReportData({

          power: { leakage: '1.45', internal: '12.80', switching: '34.20', total: '48.45' },

          timing: { wns: '0.34', tns: '0.00', fmax: '85.40' },

          area: { total: '124.60', cells: '34', util: '40.50' }

        });

      }

    } catch (error) {

      setOutput(`PPA failed:\n${error.response?.data?.error || error.message}`);

    } finally {

      setPpaLoading(false);

    }

  };



  const handleRunYosys = async () => {

    const user = auth.currentUser;

    if (!user) {

      setAuthModalMode("login");

      setShowAuthModal(true);

      return;

    }



    setSynthesisLoading(true);

    setSynthesisDone(false);

    setOutput('Starting Yosys logic synthesis...\n');

    setActiveResultTab('schematic');



    const filesWithActive = files.map(f => f.id === activeFileId ? { ...f, content: code } : f);

    const design = filesWithActive.filter(f => !f.name.startsWith('tb_') && !f.name.endsWith('.sdc'));

    const validDesign = design.filter(f => (f.content || '').trim().length > 0);



    if (validDesign.length === 0) {

      alert('Please add at least one Verilog design module file before synthesizing.');

      setSynthesisLoading(false);

      return;

    }



    try {

      const payloadFiles = toBackendFiles(validDesign);

      const runId = await submitRun({

        language: selectedLanguage.value,

        files: payloadFiles,

        topModule: synthTopModule || topModule || 'fulladd',

        runMode: 'synthesis',

        timeoutSec: 25

      });



      if (!runId) throw new Error('No run ID returned');

      setOutput(`Yosys synthesis job submitted: ${runId}\nWaiting for completion...`);



      const finalRun = await pollRun(runId);

      const [stdout, stderr] = await Promise.all([

        fetchStdout(runId),

        fetchStderr(runId),

        fetchArtifacts(runId)

      ]);



      setOutput(`Yosys Synthesis Status: ${finalRun.status}\n\n----- OUTPUT -----\n${stdout}\n\n----- ERRORS -----\n${stderr}`);



      if (finalRun.status === 'completed') {

        setSynthesisDone(true);

        fetchYosysJsonArtifact(runId);

      }

    } catch (error) {

      const errorMsg = error.response?.data?.error || error.message;

      setOutput(`Synthesis failed:\n${errorMsg}`);

    } finally {

      setSynthesisLoading(false);

    }

  };
  handleRunYosysRef.current = handleRunYosys;



  const handleRunPnR = async () => {

    const user = auth.currentUser;

    if (!user) {

      setAuthModalMode("login");

      setShowAuthModal(true);

      return;

    }



    setPnrLoading(true);

    setPnrDone(false);

    setOutput('Starting OpenROAD Place & Route...\n');

    setActiveResultTab('pnr');



    const filesWithActive = files.map(f => f.id === activeFileId ? { ...f, content: code } : f);

    const design = filesWithActive.filter(f => !f.name.startsWith('tb_') && !f.name.endsWith('.sdc'));

    const validDesign = design.filter(f => (f.content || '').trim().length > 0);



    try {

      const payloadFiles = toBackendFiles(validDesign);

      const runId = await submitRun({

        language: selectedLanguage.value,

        files: payloadFiles,

        topModule: synthTopModule || topModule || 'fulladd',

        runMode: 'pnr',

        timeoutSec: 25

      });



      if (!runId) throw new Error('No run ID returned');

      setOutput(`OpenROAD PnR job submitted: ${runId}\nWaiting for completion...`);



      const finalRun = await pollRun(runId);

      const [stdout, stderr] = await Promise.all([

        fetchStdout(runId),

        fetchStderr(runId)

      ]);



      setOutput(`OpenROAD PnR Status: ${finalRun.status}\n\n----- OUTPUT -----\n${stdout}\n\n----- ERRORS -----\n${stderr}`);



      if (finalRun.status === 'completed') {

        setPnrDone(true);

        // PnR pipeline includes synthesis — fetch its JSON to update the netlist

        fetchYosysJsonArtifact(runId);

      }

    } catch (error) {

      const errorMsg = error.response?.data?.error || error.message;

      setOutput(`PnR failed:\n${errorMsg}`);

    } finally {

      setPnrLoading(false);

    }

  };







  const handleMainRun = () => {

    if (selectedTool?.value === 'verilator_lint') {

      runCode();

    } else {

      runCode();

    }

  };
  handleMainRunRef.current = handleMainRun;





  const getCommandString = (language, files, compileArgs, runArgs, topModule) => {

    const fileNames = files.map(f => f.name).filter(n => n !== 'autogen_vcd.v' && n !== 'autogen_vcd.sv').join(' ');

    const cArgs = compileArgs ? ` ${compileArgs}` : '';

    const rArgs = runArgs ? ` ${runArgs}` : '';

    

    switch (language) {

      case 'verilog':

        return `iverilog${cArgs} ${fileNames} && vvp sim.vvp${rArgs}`;

      case 'systemverilog':

        return `verilator${cArgs} ${fileNames} && ./obj_dir/sim_bin${rArgs}`;

      case 'verilator_lint':

        return `verilator --lint-only${cArgs} ${fileNames}`;

      case 'vhdl':

        return `ghdl -a${cArgs} ${fileNames} && ghdl -e${cArgs} ${topModule || 'tb'} && ghdl -r ${topModule || 'tb'} --vcd=dump.vcd${rArgs}`;

      case 'python':

        const pyFile = files.find(f => f.name.endsWith('.py'))?.name || 'main.py';

        return `python3 ${pyFile}${rArgs}`;

      case 'c':

        return `gcc -o sim.out ${fileNames}${cArgs} && ./sim.out${rArgs}`;

      case 'cpp':

        return `g++ -o sim.out ${fileNames}${cArgs} && ./sim.out${rArgs}`;

      case 'assembly':

        const sFile = files.find(f => f.name.endsWith('.s'))?.name || 'main.s';

        return `nasm${cArgs} -o obj.o ${sFile} && ld -o sim.out obj.o && ./sim.out${rArgs}`;

      default:

        return `run ${language}`;

    }

  };



  const cleanStdout = (rawStdout) => {

    if (!rawStdout) return '';

    

    // First, remove the system logs boundaries to get clean output

    let temp = rawStdout.replace(/--- SYSTEM LOG START ---[\s\S]*?--- SYSTEM LOG END ---\n?/g, '');

    temp = temp.replace(/--- SYSTEM LOG START ---\n?/g, '');

    temp = temp.replace(/--- SYSTEM LOG END ---\n?/g, '');

    

    // Extract Verilation Report lines from the whole rawStdout (they are in compile system logs)

    const verilationLines = [];

    const rawLines = rawStdout.split('\n');

    for (const line of rawLines) {

      const trimLine = line.trim();

      if (trimLine.includes('V e r i l a t i o n   R e p o r t') ||

          trimLine.includes('Verilation Report') ||

          trimLine.includes('Verilator: Built from') ||

          trimLine.includes('Verilator: Walltime')) {

        verilationLines.push(trimLine);

      }

    }

    

    // Extract Simulation Report lines and Actual user print lines from temp

    const tempLines = temp.split('\n');

    const simulationLines = [];

    const actualLines = [];

    

    for (const line of tempLines) {

      const trimLine = line.trim();

      if (!trimLine) continue;

      

      if (trimLine.includes('S i m u l a t i o n   R e p o r t') ||

          trimLine.includes('Simulation Report') ||

          trimLine.includes('Verilator: end at') ||

          trimLine.includes('Verilator: cpu') ||

          trimLine.includes('alloced')) {

        simulationLines.push(trimLine);

      } else {

        actualLines.push(trimLine);

      }

    }

    

    // Now assemble the sections with exactly one newline gap in between

    const sections = [];

    

    if (verilationLines.length > 0) {

      sections.push(verilationLines.join('\n'));

    }

    

    if (actualLines.length > 0) {

      sections.push(actualLines.join('\n'));

    }

    

    if (simulationLines.length > 0) {

      sections.push(simulationLines.join('\n'));

    }

    

    return sections.join('\n\n');

  };



  const renderOutputConsole = (text) => {

    if (!text) return 'No compiler output logs.';

    if (text === 'Submitting run...' || text.startsWith('Run submitted:')) {

      return <div>{text}</div>;

    }

    

    const lines = text.split('\n');

    return lines.map((line, idx) => {

      const isCommandLine = idx === 0 && line.trim().startsWith('[');

      const isStatusLine = line.trim().startsWith('Status:');

      

      if (isCommandLine) {

        return (

          <div 

            key={idx} 

            style={{ 

              backgroundColor: 'rgba(234, 179, 8, 0.15)', 

              padding: '4px 8px', 

              borderRadius: '3px',

              margin: '4px 0',

              borderLeft: '4px solid #eab308',

              color: 'var(--text-main)'

            }}

          >

            {line}

          </div>

        );

      }

      

            if (isStatusLine) {
        const parts = line.split('Status:');
        const statusValue = parts[1]?.trim() || '';
        const isPass = statusValue.toLowerCase().startsWith('pass');
        const isFail = statusValue.toLowerCase().startsWith('fail');
        const isCached = statusValue.toLowerCase().includes('cached');
        const cleanStatus = isPass ? 'pass' : (isFail ? 'fail' : statusValue.split(/[\(\s]/)[0]);
        
        return (
          <div 
            key={idx} 
            style={{ 
              backgroundColor: isPass ? 'rgba(34, 197, 94, 0.12)' : (isFail ? 'rgba(239, 68, 68, 0.12)' : 'rgba(234, 179, 8, 0.15)'), 
              padding: '6px 12px', 
              borderRadius: '4px', 
              margin: '8px 0 4px 0', 
              borderLeft: `4px solid ${isPass ? '#22c55e' : (isFail ? '#ef4444' : '#eab308')}`, 
              fontWeight: 'bold', 
              color: 'var(--text-main)', 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px' 
            }} 
          > 
            <span>Status:</span> 
            <span style={{ color: isPass ? '#22c55e' : (isFail ? '#ef4444' : 'inherit') }}> 
              {cleanStatus} 
            </span> 
            {isCached && ( 
              <span style={{ 
                fontSize: '11px', 
                fontWeight: '600', 
                padding: '2px 8px', 
                borderRadius: '12px', 
                backgroundColor: 'rgba(59, 130, 246, 0.2)', 
                color: '#60a5fa', 
                border: '1px solid rgba(96, 165, 250, 0.3)', 
                display: 'inline-flex', 
                alignItems: 'center', 
                gap: '4px' 
              }}> 
                <Zap size={11} style={{ fill: '#60a5fa' }} /> cached 
              </span> 
            )} 
          </div> 
        ); 
      }

      

      return <div key={idx} style={{ minHeight: '18px' }}>{line}</div>;

    });

  };



  const parseCoverageReport = (stdout, stderr) => {

    const text = (stdout || '') + '\n' + (stderr || '');

    

    let linePct = null;

    let togglePct = null;

    let branchPct = null;

    let fsmPct = null;

    

    // 1. Covered format

    const coveredLineMatch = text.match(/Line\s+Coverage:\s*([\d\.]+)%/i);

    const coveredToggleMatch = text.match(/Toggle\s+Coverage:\s*([\d\.]+)%/i);

    const coveredBranchMatch = text.match(/Combinational\s+Logic\s+Coverage:\s*([\d\.]+)%/i);

    const coveredFsmMatch = text.match(/FSM\s+Coverage:\s*([\d\.]+)%/i);

    

    if (coveredLineMatch) linePct = parseFloat(coveredLineMatch[1]);

    if (coveredToggleMatch) togglePct = parseFloat(coveredToggleMatch[1]);

    if (coveredBranchMatch) branchPct = parseFloat(coveredBranchMatch[1]);

    if (coveredFsmMatch) fsmPct = parseFloat(coveredFsmMatch[1]);

    

    // 2. Gcov format (GHDL)

    const gcovMatch = text.match(/Lines\s+executed:\s*([\d\.]+)%/i);

    if (gcovMatch && linePct === null) {

      linePct = parseFloat(gcovMatch[1]);

    }

    

    // 3. Verilator coverage rank or percentage heuristic

    const verilatorTotalMatch = text.match(/Total\s+coverage:\s*([\d\.]+)%/i);

    if (verilatorTotalMatch) {

      linePct = parseFloat(verilatorTotalMatch[1]);

    } else {

      const allPcts = [];

      const pctRegex = /(\d+(?:\.\d+)?)%/g;

      let m;

      while ((m = pctRegex.exec(text)) !== null) {

        allPcts.push(parseFloat(m[1]));

      }

      if (allPcts.length > 0 && linePct === null) {

        linePct = allPcts[allPcts.length - 1];

      }

    }

    

    return {

      line: linePct,

      toggle: togglePct,

      branch: branchPct,

      fsm: fsmPct,

      raw: text

    };

  };



  const runCode = async () => {

    const user = auth.currentUser;

    if (!user) {

      setAuthModalMode("login");

      setShowAuthModal(true);

      return;

    }



    // Save active editor file state first

    const filesWithActive = files.map(f => f.id === activeFileId ? { ...f, content: code } : f);



    const design = filesWithActive.filter(f => !f.name.startsWith('tb_') && !f.name.endsWith('.sdc'));

    const tb = filesWithActive.filter(f => f.name.startsWith('tb_') && !f.name.endsWith('.sdc'));

    

    if (design.length === 0 && tb.length === 0) {

      alert('Please add at least one Verilog file.');

      return;

    }



    const validDesign = design.filter(f => (f.content || '').trim().length > 0);

    const validTb = tb.filter(f => (f.content || '').trim().length > 0);



    if (validDesign.length === 0 && validTb.length === 0) {

      alert('Please add content to at least one file before running.');

      return;

    }



    const language = selectedTool.value;



    setIsRunningDesign(true);

    setOutput('Submitting run...');

    setActiveResultTab('output');



    // Clear isDirty flags

    setFiles(prev => prev.map(f => ({ ...f, isDirty: false })));



    try {

      const payloadFiles = [

        ...toBackendFiles(validDesign),

        ...toBackendFiles(validTb)

      ];



      let reqCompileArgs = '';

      let reqRunArgs = '';

      let reqTopModule = testbenchModule || 'tb';



      if (language === 'verilator_lint') {

        reqTopModule = lintTopModule || '';

        let cArgs = lintAdditionalArgs || '';

        if (lintNoTop) {

          cArgs += ' --no-top';

        }

        if (lintDefines) {

          cArgs += ' ' + lintDefines.split(',').map(d => `-D${d.trim()}`).join(' ');

        }

        if (lintErrorLimit) {

          cArgs += ` --error-limit ${lintErrorLimit}`;

        }

        if (lintWarningsAsErrors) {

          cArgs += ' ' + lintWarningsAsErrors.split(',').map(w => `-Werror-${w.trim()}`).join(' ');

        }

        reqCompileArgs = cArgs;

      } else {

        reqCompileArgs = compilationArgs || '';

        reqRunArgs = runtimeArgs || '';

      }



      // Coverage options insertion

      const isCoverageOn = coverageEnabled && (language === 'verilog' || language === 'systemverilog' || language === 'vhdl');

      let coverageDelimitedArgs = '';

      if (isCoverageOn) {

        let covArgs = '';

        if (coverageTool === 'verilator') {

          if (covLine) covArgs += ' --coverage-line';

          if (covToggle) covArgs += ' --coverage-toggle';

          if (coverageCompileArgs) covArgs += ' ' + coverageCompileArgs;

          if (!covLine && !covToggle && !covBranch) {

            covArgs += ' --coverage';

          }

          reqCompileArgs += (reqCompileArgs ? ' ' : '') + covArgs.trim();

        } else if (coverageTool === 'covered') {

          let scoreParts = [];

          if (covLine) scoreParts.push('line');

          if (covToggle) scoreParts.push('toggle');

          if (covBranch) scoreParts.push('branch');

          if (covFsm) scoreParts.push('fsm');

          if (scoreParts.length > 0) {

            covArgs += ' -c ' + scoreParts.join(',');

          }

          if (coverageCompileArgs) covArgs += ' ' + coverageCompileArgs;

          coverageDelimitedArgs = covArgs.trim();

        } else if (coverageTool === 'ghdl') {

          if (coverageCompileArgs) covArgs += ' ' + coverageCompileArgs;

          reqCompileArgs += (reqCompileArgs ? ' ' : '') + covArgs.trim();

        }

      }



      if (coverageDelimitedArgs) {

        reqCompileArgs = (reqCompileArgs || '').trim() + ' //COVERAGE// ' + coverageDelimitedArgs;

      }



      const runId = await submitRun({

        language,

        files: payloadFiles,

        topModule: reqTopModule,

        timeoutSec: (language === 'systemverilog' || language === 'verilator_lint') ? 120 : 60,

        compile_args: reqCompileArgs,

        run_args: reqRunArgs,

        wave_dump: waveDumping,

        coverage: isCoverageOn

      });

      if (!runId) throw new Error('No run_id returned');



      setOutput(`Run submitted: ${runId}\nWaiting for completion...`);

      const finalRun = await pollRun(runId);

      const [stdout, stderr] = await Promise.all([

        fetchStdout(runId),

        fetchStderr(runId),

        fetchArtifacts(runId),

      ]);



      let outputText = '';

      const localDate = new Date();

      const pad = (n) => String(n).padStart(2, '0');

      const offset = -localDate.getTimezoneOffset();

      const diff = offset >= 0 ? '+' : '-';

      const tzOffsetStr = `GMT${diff}${pad(Math.floor(Math.abs(offset) / 60))}:${pad(Math.abs(offset) % 60)}`;

      const timestamp = `${localDate.getFullYear()}-${pad(localDate.getMonth() + 1)}-${pad(localDate.getDate())} ${pad(localDate.getHours())}:${pad(localDate.getMinutes())}:${pad(localDate.getSeconds())} ${tzOffsetStr}`;

      const cmdStr = getCommandString(language, payloadFiles, reqCompileArgs, reqRunArgs, reqTopModule);

      outputText += `[${timestamp}] ${cmdStr}\n`;



      const cleanedStdout = cleanStdout(stdout);

      if (cleanedStdout) {

        outputText += cleanedStdout + '\n';

      }



      if (finalRun.status === 'failed' || (stderr && (stderr.toLowerCase().includes('error') || stderr.toLowerCase().includes('fatal')))) {

        outputText += `\n----- STDERR -----\n${stderr}\n`;

      }



      const statusMap = {

        completed: 'pass',

        failed: 'fail'

      };

      const displayStatus = statusMap[finalRun.status] || finalRun.status;

      outputText += `\nStatus: ${displayStatus}`;

      if (finalRun.cached) {

        outputText += ` (cached)`;

      }

      setOutput(outputText);



      if (isCoverageOn && finalRun.status === 'completed') {

        const parsed = parseCoverageReport(stdout, stderr);

        setCoverageReportData(parsed);

        setActiveResultTab('coverage');

      }



      if (language !== 'verilator_lint' && (language === 'verilog' || language === 'systemverilog') && finalRun.status === 'completed' && waveDumping !== 'none') {

        await fetchVcdArtifact(runId);

        setActiveResultTab('waveform');

      }



    } catch (error) {

      const errorMsg = error.response?.data?.error || error.message;

      setOutput(`Execution failed:\n${errorMsg}`);

    } finally {

      setIsRunningDesign(false);

    }

  };







  const restoreSavedProject = (project) => {

    // Restore primary and TB files into a single unified list

    const combinedRestored = [];

    

    if (project.designFiles && project.designFiles.length > 0) {

      project.designFiles.forEach((f, idx) => {

        combinedRestored.push({

          id: Date.now() + idx,

          name: f.name,

          content: f.content || '',

          language: f.language || 'verilog',

          extension: f.extension || (f.name.endsWith('.sv') ? '.sv' : '.v'),

          monaco: f.language || 'verilog',

          isDirty: false

        });

      });

    }



    if (project.tbFiles && project.tbFiles.length > 0) {

      project.tbFiles.forEach((f, idx) => {

        combinedRestored.push({

          id: Date.now() + idx + 100,

          name: f.name,

          content: f.content || '',

          language: f.language || 'verilog',

          extension: f.extension || (f.name.endsWith('.sv') ? '.sv' : '.v'),

          monaco: f.language || 'verilog',

          isDirty: false

        });

      });

    }



    if (combinedRestored.length > 0) {

      setFiles(combinedRestored);

      setActiveFileId(combinedRestored[0].id);

      setCode(combinedRestored[0].content || '');

      setOpenTabIds(combinedRestored.map(f => f.id));

      

      // Attempt to extract top module names

      const topDesign = findTopModuleFromFiles(combinedRestored.filter(f => !f.name.startsWith('tb_')));

      const topTb = findTopModuleFromFiles(combinedRestored.filter(f => f.name.startsWith('tb_')));

      if (topDesign) setTopModule(topDesign);

      if (topTb) setTestbenchModule(topTb);

      updateToolFromFilename(combinedRestored[0].name);

    }



    setActiveProjectTitle(project.title || 'untitled');

    setSavedProjectTitle(project.title || 'untitled');

    setActiveProjectId(project.id || null);

    setSynthesisDone(false);

    setPnrDone(false);

    setPpaReportData(null);

    setVcdContent('');



    // Sync design language from project

    const designLang = languageOptions.find(opt => opt.value === project.primaryLanguage) || languageOptions[0];

    setSelectedLanguage(designLang);



    // Sync tbDesignLang and selectedTool

    const extToLang = {

      verilog: 'systemverilog',

      systemverilog: 'systemverilog',

      vhdl: 'vhdl',

      python: 'python',

      cpp: 'cpp',

      c: 'c',

      assembly: 'assembly'

    };

    const langValue = extToLang[designLang.value] || 'systemverilog';

    setTbDesignLang(langValue);

    const tools = languageToTools[langValue] || [];

    if (tools.length > 0) {

      const matchingTool = tools.find(t => t.value === designLang.value) || tools[0];

      setSelectedTool(matchingTool);

    }



    setView('playground');

  };



  const saveCodeToBackend = async () => {

    const user = auth.currentUser;

    if (!user) {

      setAuthModalMode("login");

      setShowAuthModal(true);

      return;

    }

    // Simple validation

    if (files.length === 0) {

      alert("Nothing to save!");

      return;

    }

    setSaveTitle(activeProjectTitle === 'untitled' ? '' : activeProjectTitle);

    setShowSaveModal(true);

  };



  const confirmSaveToBackend = async () => {

    if (!saveTitle.trim()) {

      alert("Please provide a project name.");

      return;

    }



    const user = auth.currentUser;

    setIsCurrentlySaving(true);

    try {

      // Save current code to active file in payload

      const filesWithActive = files.map(f => f.id === activeFileId ? { ...f, content: code } : f);



      const designPayload = filesWithActive.filter(f => !f.name.startsWith('tb_')).map(f => ({

        name: f.name,

        content: f.content || '',

        language: f.language,

        extension: f.extension

      }));



      const tbPayload = filesWithActive.filter(f => f.name.startsWith('tb_')).map(f => ({

        name: f.name,

        content: f.content || '',

        language: f.language,

        extension: f.extension

      }));



      const saveData = {

        userId: user.uid,

        userEmail: user.email,

        title: saveTitle,

        designFiles: designPayload,

        tbFiles: tbPayload,

        timestamp: serverTimestamp(),

        totalFiles: files.length,

        primaryLanguage: designPayload[0]?.language || 'verilog'

      };



      if (activeProjectId) {

        // Update existing project

        const projectRef = doc(db, "codeProjects", activeProjectId);

        await updateDoc(projectRef, saveData);

      } else {

        // Create new project

        const docRef = await addDoc(collection(db, "codeProjects"), saveData);

        setActiveProjectId(docRef.id);

      }

      setFiles(prev => prev.map(f => ({ ...f, isDirty: false })));

      setActiveProjectTitle(saveTitle);

      setSavedProjectTitle(saveTitle);

      setShowSaveModal(false);

      setSaveTitle('');

      alert("Project saved successfully!");

    } catch (error) {

      console.error("Save error:", error);

      alert(`Failed to save: ${error.message}`);

    } finally {

      setIsCurrentlySaving(false);

    }

  };















  // Suppress standard ResizeObserver loop error

  React.useEffect(() => {

    const handleError = (e) => {

      if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {

        e.stopImmediatePropagation();

      }

    };

    window.addEventListener('error', handleError);

    return () => window.removeEventListener('error', handleError);

  }, []);



  // Autosave implementation

  React.useEffect(() => {

    if (autosaveStatus !== 'dirty') return;

    

    setAutosaveStatus('saving');

    const timer = setTimeout(async () => {

      try {

        const user = auth.currentUser;

        if (!user || !activeProjectId) {

          setAutosaveStatus('saved');

          return;

        }



        const filesWithActive = files.map(f => f.id === activeFileId ? { ...f, content: code } : f);

        

        const designPayload = filesWithActive.filter(f => !f.name.startsWith('tb_')).map(f => ({

          name: f.name,

          content: f.content || '',

          language: f.language || 'systemverilog',

          extension: f.extension || '.sv'

        }));



        const tbPayload = filesWithActive.filter(f => f.name.startsWith('tb_')).map(f => ({

          name: f.name,

          content: f.content || '',

          language: f.language || 'systemverilog',

          extension: f.extension || '.sv'

        }));



        const projectRef = doc(db, 'codeProjects', activeProjectId);

        await updateDoc(projectRef, {

          designFiles: designPayload,

          tbFiles: tbPayload,

          updatedAt: serverTimestamp()

        });

        setAutosaveStatus('saved');

        setSavedProjectTitle(activeProjectTitle);

        setFiles(prev => prev.map(f => ({ ...f, isDirty: false })));

      } catch (err) {

        console.error('Autosave failed:', err);

        setAutosaveStatus('saved');

      }

    }, 2000); // 2 second debounce



    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [code, files, activeFileId, activeProjectId]);



  // Load project passed from Profile Page state on startup

  React.useEffect(() => {

    if (location.state && location.state.projectToLoad) {

      const proj = location.state.projectToLoad;

      restoreSavedProject(proj);

      // Clear location state to prevent reload loops

      navigate(location.pathname, { replace: true, state: {} });

    }

  }, [location, navigate]);



  // Load challenge passed from Challenges Page on startup

  React.useEffect(() => {

    const activeChallengeStr = localStorage.getItem('active_challenge');

    if (activeChallengeStr) {

      try {

        const challenge = JSON.parse(activeChallengeStr);

        setActiveProjectTitle(challenge.title);

        setSavedProjectTitle(challenge.title);

        setActiveProjectId(null);



        const designFileName = `${challenge.id}.sv`;

        const tbFileName = `tb_${challenge.id}.sv`;

        

        const challengeFiles = [

          {

            id: 1,

            name: designFileName,

            language: 'systemverilog',

            monaco: 'systemverilog',

            extension: '.sv',

            content: challenge.designTemplate,

            isDirty: false

          },

          {

            id: 2,

            name: tbFileName,

            language: 'systemverilog',

            monaco: 'systemverilog',

            extension: '.sv',

            content: challenge.tbTemplate,

            isDirty: false

          }

        ];



        setFiles(challengeFiles);

        setActiveFileId(1);

        setCode(challenge.designTemplate);

        setOpenTabIds([1, 2]);



        setTopModule(challenge.id);

        setTestbenchModule(`tb_${challenge.id}`);

        

        setAutosaveStatus('dirty');

      } catch (err) {

        console.error('Error parsing active challenge:', err);

      } finally {

        localStorage.removeItem('active_challenge');

      }

    }

  }, []);



  // Load example passed from Examples Page on startup

  React.useEffect(() => {

    const activeExampleStr = localStorage.getItem('active_example');

    if (activeExampleStr) {

      try {

        const example = JSON.parse(activeExampleStr);

        setActiveProjectTitle(example.title);

        setSavedProjectTitle(example.title);

        setActiveProjectId(null);



        const ext = example.language === 'Verilog' ? '.v' : '.sv';

        const langKey = example.language === 'Verilog' ? 'verilog' : 'systemverilog';

        const designFileName = `${example.id}${ext}`;

        const tbFileName = `tb_${example.id}${ext}`;



        const exampleFiles = [

          {

            id: 1,

            name: designFileName,

            language: langKey,

            monaco: langKey,

            extension: ext,

            content: example.designTemplate,

            isDirty: false

          },

          {

            id: 2,

            name: tbFileName,

            language: langKey,

            monaco: langKey,

            extension: ext,

            content: example.tbTemplate,

            isDirty: false

          }

        ];



        setFiles(exampleFiles);

        setActiveFileId(1);

        setCode(example.designTemplate);

        setOpenTabIds([1, 2]);



        setTopModule(example.id);

        setTestbenchModule(`tb_${example.id}`);

        

        const designLang = languageOptions.find(o => o.value === langKey);

        if (designLang) {

          setSelectedLanguage(designLang);

        }



        setAutosaveStatus('dirty');

      } catch (err) {

        console.error('Error parsing active example:', err);

      } finally {

        localStorage.removeItem('active_example');

      }

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);



  // Keyboard Shortcuts implementation

  React.useEffect(() => {

    const handleKeyDown = (e) => {

      if (e.altKey) {

        if (e.key === 'r' || e.key === 'R') {

          e.preventDefault();

          handleMainRun();

        } else if (e.key === 'n' || e.key === 'N') {

          e.preventDefault();

          handleAddFile();

        } else if (e.key === 'b' || e.key === 'B') {

          e.preventDefault();

          setSidebarOpen(prev => !prev);

        } else if (e.key === 'x' || e.key === 'X') {

          e.preventDefault();

          setOutput('');

        }

      }

    };



    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);

  }, [files, code, activeFileId, selectedTool]);



  const handleShareProject = () => {

    if (!activeProjectId) {

      alert("Please save your project first before sharing.");

      return;

    }

    const shareUrl = `${window.location.origin}/codebox?project=${activeProjectId}`;

    navigator.clipboard.writeText(shareUrl)

      .then(() => {

        alert("Project sharing link copied to clipboard:\n" + shareUrl);

      })

      .catch((err) => {

        console.error("Could not copy text: ", err);

      });

  };



  const handleDownloadZip = () => {

    const zip = new JSZip();

    files.forEach(f => {

      const content = f.id === activeFileId ? code : (f.content || '');

      zip.file(f.name, content);

    });

    

    zip.generateAsync({ type: 'blob' }).then((content) => {

      const element = document.createElement("a");

      element.href = URL.createObjectURL(content);

      element.download = `${activeProjectTitle.replace(/\s+/g, '_')}.zip`;

      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

    });

  };





  const handleProceedLearn = () => {

    window.open(buildMainUrl('/learning'), '_blank');

    setShowLearnModal(false);

  };



  const handleNewProject = () => {

    if (isProjectDirty) {

      if (!window.confirm("You have unsaved changes. Starting a new project will lose these changes. Continue?")) {

        return;

      }

    }



    setActiveProjectTitle('untitled');

    setSavedProjectTitle('untitled');

    setActiveProjectId(null);



    const initialFiles = [

      {

        id: 1,

        name: 'design_top.sv',

        language: 'systemverilog',

        monaco: 'systemverilog',

        extension: '.sv',

        content: '',

        isDirty: false

      }

    ];



    setFiles(initialFiles);

    setActiveFileId(1);

    setCode('');

    setOpenTabIds([1]);

    setTopModule('');

    setTestbenchModule('');

    setSynthesisDone(false);

    setPnrDone(false);

    setPpaReportData(null);

    setVcdContent('');

    setOutput('');



    // Reset language & tools to default

    setSelectedLanguage({ value: 'systemverilog', label: 'SystemVerilog', extension: '.sv', monaco: 'systemverilog' });

    setTbDesignLang('systemverilog');

    setSelectedTool({ value: 'verilog', label: 'Icarus Verilog 12.0', mode: 'simulation' });

    

    // Reset options and args

    setCompilationArgs('-Wall -g2012');

    setRuntimeArgs('');

    setRunTimeLimit('10 ms');



    // Reset lint settings

    setLintTopModule('');

    setLintNoTop(false);

    setLintDefines('');

    setLintErrorLimit('50');

    setLintWarningsAsErrors('');

    setLintAdditionalArgs('-Wall');



    // Reset waveform and timescale

    setWaveDumping('none');

    setTimescale('1ns/1ps');



    // Reset coverage

    setCoverageEnabled(false);

    setCoverageTool('verilator');

    setCovLine(true);

    setCovToggle(false);

    setCovBranch(false);

    setCovFsm(false);

    setCoverageCompileArgs('');

    setCoverageReportData(null);

    setCoverageOpen(false);



    // Reset advanced libraries options

    setLibrariesOpen(false);

    setUvmOvm('none');

    setOtherLibs(['none']);

    setEnableTlVerilog(false);

    setEnableEasierUvm(false);

    setEnableVUnit(false);



    // Reset synthesis & PnR configurations

    setSelectedSynthTarget('sky130');

    setSynthFlatten(true);

    setSynthOptimize('-O2');

    setSynthTopModule('');

    setAbcTarget('balanced');

    setClockGating(false);

    setSdcFile('autodetect');

    setMaxTransition('0.5');

    setMaxCapacitance('50.0');

    setPnrAutoDie(true);

    setPnrAspectRatio('1.0');

    setPnrCts(true);

    setTimingCorner('typical');

    setClockPeriod('10.0');

    setTimingOptimize(true);

    setPpaTemperature('25');

    setPpaVoltage('1.8');

    setPpaCapacitance('10.0');

    setPpaCellLibrary('sky130_fd_sc_hd');



    // Reset layout settings / checkbox options

    setUseRunBash(false);

    setShowOutputText(false);

    setShowOutputSvg(false);

    setOutputSvgFilename('');

    setDownloadFiles(false);

  };

  const isLight = theme === 'light';

  const customSelectStyles = {

    control: (base) => ({

      ...base,

      minHeight: '30px',

      height: '30px',

      fontSize: '0.85rem',

      backgroundColor: isLight ? '#ffffff' : '#090d16',

      borderColor: isLight ? '#cbd5e1' : '#1e293b',

      boxShadow: 'none',

      '&:hover': { borderColor: isLight ? '#3b82f6' : '#4f46e5' }

    }),

    valueContainer: (base) => ({ ...base, padding: '0 8px' }),

    input: (base) => ({ 

      ...base, 

      margin: '0', 

      padding: '0',

      color: isLight ? '#0f172a' : '#f1f5f9'

    }),

    singleValue: (base) => ({

      ...base,

      color: isLight ? '#0f172a' : '#f1f5f9'

    }),

    placeholder: (base) => ({

      ...base,

      color: isLight ? '#64748b' : '#94a3b8'

    }),

    indicatorsContainer: (base) => ({ ...base, height: '28px' }),

    dropdownIndicator: (base) => ({ 

      ...base, 

      padding: '2px',

      color: isLight ? '#64748b' : '#94a3b8',

      '&:hover': {

        color: isLight ? '#0f172a' : '#f1f5f9'

      }

    }),

    indicatorSeparator: (base) => ({ 

      ...base, 

      backgroundColor: isLight ? '#cbd5e1' : '#1e293b'

    }),

    clearIndicator: (base) => ({ ...base, padding: '2px' }),

    menu: (base) => ({ 

      ...base, 

      fontSize: '0.85rem', 

      backgroundColor: isLight ? '#ffffff' : '#090d16', 

      border: `1px solid ${isLight ? '#cbd5e1' : '#1e293b'}`,

      zIndex: 999

    }),

    option: (base, state) => ({

      ...base,

      backgroundColor: state.isSelected 

        ? (isLight ? '#2563eb' : '#4f46e5') 

        : state.isFocused 

          ? (isLight ? '#f1f5f9' : '#1e293b') 

          : (isLight ? '#ffffff' : '#090d16'),

      color: state.isSelected 

        ? '#ffffff' 

        : (isLight ? '#0f172a' : '#f1f5f9'),

      cursor: 'pointer',

      '&:active': {

        backgroundColor: isLight ? '#2563eb' : '#4f46e5'

      }

    })

  };



  return (

    <div className={`${styles.codeTestContainer} ${theme === 'light' ? styles.lightTheme : ''}`} ref={containerRef}>

      <div className={styles.header}>

        {/* Left Side: Brand Logo and File / Layout / Learn Menus */}

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.1rem', flex: '1 1 0%' }}>

          <div className={styles.logoContainer} onClick={() => navigate('/page')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>

            <img src="/static_img/weblogo.png" alt="SiliconLogix Logo" className={styles.webLogo} />

          </div>

          

          <div style={{ borderLeft: '1px solid var(--border-color)', height: '18px', margin: '0 4px' }}></div>

          

          {/* File Menu Dropdown */}

          <div className={styles.fileMenuContainer}>

            <button className={styles.fileMenuTrigger} onClick={() => setFileDropdownOpen(!fileDropdownOpen)}>

              <Folder size={14} style={{ color: '#94a3b8' }} />

              <span>File</span>

            </button>

            {fileDropdownOpen && (

              <div className={styles.fileDropdown}>

                <div className={styles.fileDropdownItem} onClick={() => { handleNewProject(); setFileDropdownOpen(false); }}>

                  <File size={13} style={{ color: '#94a3b8' }} />

                  <span>New Project</span>

                </div>

                <div className={styles.fileDropdownItem} onClick={() => { saveCodeToBackend(); setFileDropdownOpen(false); }}>

                  <Save size={13} style={{ color: '#94a3b8' }} />

                  <span>Save Project</span>

                </div>

                <div className={styles.fileDropdownItem} onClick={() => { setView('gallery'); setFileDropdownOpen(false); }}>

                  <Folder size={13} style={{ color: '#94a3b8' }} />

                  <span>Browse Projects</span>

                </div>

                <div className={styles.fileDropdownItem} onClick={() => { handleShareProject(); setFileDropdownOpen(false); }}>

                  <Share2 size={13} style={{ color: '#94a3b8' }} />

                  <span>Share Project</span>

                </div>

                <div style={{ height: '1px', backgroundColor: 'var(--border-color)', margin: '4px 0' }}></div>

                <div className={styles.fileDropdownItem} onClick={() => { handleDownloadZip(); setFileDropdownOpen(false); }}>

                  <Download size={13} style={{ color: '#94a3b8' }} />

                  <span>Download as ZIP</span>

                </div>

              </div>

            )}

          </div>



          {/* Layout Menu Visual Placeholder */}

          {/* <button className={styles.fileMenuTrigger} style={{ cursor: 'default' }}>

            <Layout size={14} style={{ color: '#94a3b8' }} />

            <span>Layout</span>

          </button> */}

          

          {/* Learn Menu Button */}

          <button className={styles.fileMenuTrigger} onClick={() => setShowLearnModal(true)}>

            <BookOpen size={14} style={{ color: '#94a3b8' }} />

            <span>Learn</span>

          </button>

        </div>



        {/* Center Side: Project Title and Saved/Not-Saved Status Indicator */}

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: '1 1 0%' }}>

          {view === 'playground' ? (

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

              <span style={{ fontSize: '0.95rem', fontWeight: 600, color: 'var(--text-muted)', userSelect: 'none' }}>

                Codebox - 

              </span>

              {isRenamingProject ? (

                <input

                  autoFocus

                  className={styles.projectTitleInput}

                  value={projectTitleDraft}

                  onChange={(e) => setProjectTitleDraft(e.target.value)}

                  onBlur={() => {

                    if (projectTitleDraft.trim()) setActiveProjectTitle(projectTitleDraft.trim());

                    setIsRenamingProject(false);

                  }}

                  onKeyDown={(e) => {

                    if (e.key === 'Enter') {

                      if (projectTitleDraft.trim()) setActiveProjectTitle(projectTitleDraft.trim());

                      setIsRenamingProject(false);

                    } else if (e.key === 'Escape') {

                      setIsRenamingProject(false);

                    }

                  }}

                  style={{

                    fontSize: '0.95rem',

                    fontWeight: 600,

                    padding: '2px 6px',

                    width: '120px'

                  }}

                />

              ) : (

                <h4

                  className={styles.title}

                  onDoubleClick={() => {

                    setProjectTitleDraft(activeProjectTitle);

                    setIsRenamingProject(true);

                  }}

                  title="Double click to rename project"

                  style={{ margin: 0, fontWeight: 600, fontSize: '0.95rem' }}

                >

                  {activeProjectTitle}

                </h4>

              )}

              

              <span 

                style={{ 

                  display: 'inline-flex', 

                  alignItems: 'center', 

                  gap: '4px', 

                  fontSize: '11px', 

                  color: isProjectDirty ? '#f97316' : '#22c55e',

                  fontWeight: '600',

                  backgroundColor: isProjectDirty ? 'rgba(249, 115, 22, 0.1)' : 'rgba(34, 197, 94, 0.1)',

                  padding: '2px 8px',

                  borderRadius: '12px',

                  border: `1px solid ${isProjectDirty ? 'rgba(249, 115, 22, 0.2)' : 'rgba(34, 197, 94, 0.2)'}`,

                  userSelect: 'none'

                }}

                title={isProjectDirty ? "Unsaved changes exist" : "Project is saved"}

              >

                {isProjectDirty ? (

                  <>

                    <span style={{ 

                      width: '6px', 

                      height: '6px', 

                      borderRadius: '50%', 

                      backgroundColor: '#f97316' 

                    }}></span>

                    <span style={{ color: '#f97316' }}>Not Saved</span>

                  </>

                ) : (

                  <>

                    <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#22c55e', display: 'inline-flex', alignItems: 'center' }}>
                      <Check size={12} color="#22c55e" />
                    </span>
                    <span style={{ color: '#22c55e' }}>Saved</span>

                  </>

                )}

              </span>

            </div>

          ) : (

            <h3 className={styles.title} style={{ margin: 0 }}>Your CodeBox</h3>

          )}

        </div>



        {/* Right Side: Toolbar, Autosave, Run, and User menu dropdown */}

        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', justifyContent: 'flex-end', flex: '1 1 0%' }}>

          {view === 'playground' ? (

            <>

              {/* Autosave status indicator */}

              {activeProjectId && (

                <span style={{ fontSize: '11px', color: autosaveStatus === 'saving' ? '#ef4444' : '#10b981', display: 'flex', alignItems: 'center', gap: '6px', marginRight: '8px' }}>

                  <span style={{ 

                    width: '6px', 

                    height: '6px', 

                    borderRadius: '50%', 

                    background: autosaveStatus === 'saving' ? '#ef4444' : '#10b981'

                  }}></span>

                  {autosaveStatus === 'saving' ? 'Saving...' : 'Saved'}

                </span>

              )}



            </>

          ) : (

            <button className={styles.headerRunBtn} onClick={() => setView('playground')}>

              <ArrowLeft size={16} /> Back to Editor

            </button>

          )}



          {/* User Profile avatar or sign in button */}

          <div className={styles.userMenuContainer}>

            <button className={styles.themeToggleBtn} onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')} title="Switch theme">

              {theme === 'light' ? <Moon size={16} /> : <Sun size={16} />}

            </button>

            {isAuthenticated ? (

              <UserProfileDropdown userDetails={userDetails} styles={styles} />

            ) : (

              <button 

                className={styles.loginBtn}

                onClick={() => {

                  setAuthModalMode("login");

                  setShowAuthModal(true);

                }}

              >

                Sign In

              </button>

            )}

          </div>

        </div>

      </div>



      {view === 'playground' ? (

        <div style={{ display: 'flex', flex: 1, overflow: 'hidden', height: 'calc(100vh - 40px)', backgroundColor: '#030712' }}>

          

          {/* Activity Bar (Far Left) */}

          <div className={styles.activityBar}>

            <div 

              className={`${styles.activityIcon} ${activeSidebarTab === 'files' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('files')}

              title="File Explorer"

            >

              <Folder size={20} />

            </div>

            <div 

              className={`${styles.activityIcon} ${activeSidebarTab === 'simulation' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('simulation')}

              title="Tools & Simulators"

            >

              <Play size={20} />

            </div>

            <div 

              className={`${styles.activityIcon} ${activeSidebarTab === 'synthesis' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('synthesis')}

              title="Logic Synthesis"

            >

              <Cpu size={20} />

            </div>

            <div 

              className={`${styles.activityIcon} ${activeSidebarTab === 'timing' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('timing')}

              title="Static Timing Analysis"

            >

              <Clock size={20} />

            </div>

            <div 

              className={`${styles.activityIcon} ${activeSidebarTab === 'ppa' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('ppa')}

              title="Power, Performance & Area (PPA)"

            >

              <Sliders size={20} />

            </div>

            <div 

              className={`${styles.activityIcon} ${activeSidebarTab === 'pnr' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('pnr')}

              title="Place & Route"

            >

              <Layers size={20} />

            </div>

            <div

              className={`${styles.activityIcon} ${activeSidebarTab === 'ai' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('ai')}

              title="AI Helper"

            >

              <MessageSquare size={20} />

            </div>

            <div 

              className={`${styles.activityIcon} ${activeSidebarTab === 'settings' && sidebarOpen ? styles.activeActivityIcon : ''}`}

              onClick={() => handleActivityTabClick('settings')}

              title="Settings"

            >

              <Settings size={20} />

            </div>

          </div>



          {/* Left Sidebar Content Panel */}

          {sidebarOpen && (

            <div className={styles.sidebarPanel}>

              {activeSidebarTab === 'files' && (

                <FileExplorer

                  files={files}

                  activeFileId={activeFileId}

                  onSelectFile={handleSelectFile}

                  onAddFile={handleAddFile}

                  onDeleteFile={handleDeleteFile}

                  onRenameFile={handleRenameFile}

                  topModule={topModule}

                  setTopModule={setTopModule}

                  testbenchModule={testbenchModule}

                  setTestbenchModule={setTestbenchModule}

                  onReorderFiles={handleReorderFiles}

                />

              )}

              

              {activeSidebarTab === 'simulation' && (

                <div className={styles.simulationPanel}>

                  {/* Simulation Pannel */}

                  <div className={styles.sidebarPanelTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <Play size={14} style={{ color: '#60a5fa' }} /> Simulation & Coverage

                  </div>

                  

                  {/* Language Header */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Language</label>

                    <div className={styles.toolSelectorContainer}>

                      <Select

                        value={designLanguageOptions.find(o => o.value === tbDesignLang)}

                        onChange={(opt) => handleLangChange(opt)}

                        options={designLanguageOptions}

                        styles={customSelectStyles}

                        placeholder="Select Language"

                      />

                    </div>

                  </div>







                  {/* Tools & Simulators Header */}

                  {/* <div className={styles.sidebarPanelTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px', borderTop: '1px solid var(--border-color)', paddingTop: '12px' }}>

                    <Cpu size={14} style={{ color: '#34d399' }} /> Simulation

                  </div> */}



                  {/* Tool selection */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Sim Tool</label>

                    <div className={styles.toolSelectorContainer}>

                      <Select

                        value={selectedTool}

                        onChange={(opt) => setSelectedTool(opt)}

                        options={languageToTools[tbDesignLang] || []}

                        styles={customSelectStyles}

                        placeholder="Select Tool"

                      />

                    </div>

                  </div>



                  {/* Dynamic fields based on simulator vs linter */}

                  {selectedTool?.value !== 'verilator_lint' ? (

                    <>

                      {/* Compile Options */}

                      <div className={styles.sidebarSection}>

                        <label className={styles.sidebarLabel}>Compile Options</label>

                        <input 

                          type="text" 

                          className={styles.sidebarInput} 

                          value={compilationArgs} 

                          onChange={(e) => setCompilationArgs(e.target.value)}

                          placeholder="Compile Options"

                        />

                      </div>



                      {/* Run Options */}

                      <div className={styles.sidebarSection}>

                        <label className={styles.sidebarLabel}>Run Options</label>

                        <input 

                          type="text" 

                          className={styles.sidebarInput} 

                          value={runtimeArgs} 

                          onChange={(e) => setRuntimeArgs(e.target.value)}

                          placeholder="Run Options" 

                        />

                      </div>



                      {/* Run Time for Verilator simulator */}

                      {selectedTool?.value === 'systemverilog' && (

                        <div className={styles.sidebarSection}>

                          <label className={styles.sidebarLabel}>Run Time</label>

                          <input 

                            type="text" 

                            className={styles.sidebarInput} 

                            value={runTimeLimit} 

                            onChange={(e) => setRunTimeLimit(e.target.value)}

                            placeholder="10 ms" 

                          />

                        </div>

                      )}



                      {/* Waveform Dumping & Timescale */}

                      {(tbDesignLang === 'systemverilog' || tbDesignLang === 'vhdl') && (

                        <>

                          {/* Waveform Dumping */}

                          <div className={styles.sidebarSection}>

                            <label className={styles.sidebarLabel}>Waveform Dumping</label>

                            <select

                              className={styles.sidebarInput}

                              value={waveDumping}

                              onChange={(e) => setWaveDumping(e.target.value)}

                            >

                              <option value="epwave">EPWave viewer (VCD format)</option>

                              <option value="vcd">Surfer Viewer (VCD format)</option>

                              <option value="fst">FST format (fast compressed)</option>

                              <option value="none">Disable Waveform Dumping</option>

                            </select>

                          </div>



                          {/* Timescale */}

                          <div className={styles.sidebarSection}>

                            <label className={styles.sidebarLabel}>Default Timescale</label>

                            <select

                              className={styles.sidebarInput}

                              value={timescale}

                              onChange={(e) => setTimescale(e.target.value)}

                            >

                              <option value="1ns/1ps">1ns / 1ps</option>

                              <option value="10ns/1ns">10ns / 1ns</option>

                              <option value="1ps/1ps">1ps / 1ps</option>

                              <option value="1us/1ns">1us / 1ns</option>

                            </select>

                          </div>

                        </>

                      )}



                          {/* Code Coverage Collapsible Drawer */}

                          {(tbDesignLang === 'systemverilog' || tbDesignLang === 'vhdl') && (

                            <>

                              <div className={styles.drawerHeader} onClick={() => setCoverageOpen(!coverageOpen)} style={{ marginTop: '12px' }}>

                                <span>CODE COVERAGE</span>

                                <span>{coverageOpen ? '▾' : '▸'}</span>

                              </div>

                              {coverageOpen && (

                                <div className={styles.drawerContent} style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '8px' }}>

                                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#fff', cursor: 'pointer', fontWeight: 'bold', marginBottom: '4px' }}>

                                    <input

                                      type="checkbox"

                                      checked={coverageEnabled}

                                      onChange={(e) => setCoverageEnabled(e.target.checked)}

                                    />

                                    Enable Code Coverage

                                  </label>

                                  

                                  {coverageEnabled && (

                                    <>

                                      <div>

                                        <label className={styles.sidebarLabel} style={{ fontSize: '10px' }}>Coverage Tool</label>

                                        <select

                                          className={styles.sidebarInput}

                                          value={coverageTool}

                                          onChange={(e) => setCoverageTool(e.target.value)}

                                          style={{ fontSize: '10px' }}

                                        >

                                          {tbDesignLang === 'systemverilog' ? (

                                            <>

                                              <option value="verilator">Verilator Coverage</option>

                                              <option value="covered">Covered (Verilog only)</option>

                                            </>

                                          ) : (

                                            <option value="ghdl">GHDL + Gcov</option>

                                          )}

                                        </select>

                                      </div>



                                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '4px' }}>

                                        <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                          <input

                                            type="checkbox"

                                            checked={covLine}

                                            onChange={(e) => setCovLine(e.target.checked)}

                                          />

                                          Line / Statement Coverage

                                        </label>

                                        <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                          <input

                                            type="checkbox"

                                            checked={covToggle}

                                            onChange={(e) => setCovToggle(e.target.checked)}

                                          />

                                          Toggle / Port Coverage

                                        </label>

                                        <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                          <input

                                            type="checkbox"

                                            checked={covBranch}

                                            onChange={(e) => setCovBranch(e.target.checked)}

                                          />

                                          Branch / Decision Coverage

                                        </label>

                                        {coverageTool === 'covered' && (

                                          <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                            <input

                                              type="checkbox"

                                              checked={covFsm}

                                              onChange={(e) => setCovFsm(e.target.checked)}

                                            />

                                            FSM Coverage

                                          </label>

                                        )}

                                      </div>



                                      <div style={{ marginTop: '4px' }}>

                                        <label className={styles.sidebarLabel} style={{ fontSize: '10px' }}>Coverage Compile Args</label>

                                        <input

                                          type="text"

                                          className={styles.sidebarInput}

                                          value={coverageCompileArgs}

                                          onChange={(e) => setCoverageCompileArgs(e.target.value)}

                                          placeholder="e.g. --coverage-line"

                                          style={{ fontSize: '10px' }}

                                        />

                                      </div>

                                    </>

                                  )}

                                </div>

                              )}

                            </>

                          )}



                      {/* Advanced Options Collapsible Drawer */}

                      <> 

                        <div className={styles.drawerHeader} onClick={() => setLibrariesOpen(!librariesOpen)} style={{ marginTop: '12px' }}>

                          <span>ADVANCED OPTIONS</span>

                          <span>{librariesOpen ? '▾' : '▸'}</span>

                        </div>

                        {librariesOpen && (

                          <div className={styles.drawerContent} style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '8px' }}>

                            {/* SystemVerilog Library specific controls */}

                            {tbDesignLang === 'systemverilog' && (

                              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', borderTop: '1px solid #1e293b', paddingTop: '8px', marginTop: '4px' }}>

                                <div>

                                  <label className={styles.sidebarLabel} style={{ fontSize: '10px' }}>UVM / OVM</label>

                                  <Select

                                    value={uvmOvmOptions.find(o => o.value === uvmOvm)}

                                    onChange={(opt) => setUvmOvm(opt.value)}

                                    options={uvmOvmOptions}

                                    styles={customSelectStyles}

                                    placeholder="Select UVM/OVM"

                                  />

                                </div>

                                <div>

                                  <label className={styles.sidebarLabel} style={{ fontSize: '10px', marginBottom: '6px' }}>Libraries (Others)</label>

                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', paddingLeft: '2px' }}>

                                    {otherLibsOptions.map((opt) => (

                                      <label key={opt.value} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                        <input

                                          type="checkbox"

                                          checked={otherLibs.includes(opt.value)}

                                          onChange={() => {

                                            const value = opt.value;

                                            if (value === 'none') {

                                              setOtherLibs(['none']);

                                            } else {

                                              setOtherLibs(prev => {

                                                let next;

                                                if (prev.includes(value)) {

                                                  next = prev.filter(v => v !== value);

                                                } else {

                                                  next = [...prev.filter(v => v !== 'none'), value];

                                                }

                                                return next.length === 0 ? ['none'] : next;

                                              });

                                            }

                                          }}

                                        />

                                        {opt.label}

                                      </label>

                                    ))}

                                  </div>

                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '4px' }}>

                                  <label className={styles.sidebarLabel} style={{ fontSize: '10px', marginBottom: '6px' }}>Extra Options</label>

                                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                    <input

                                      type="checkbox"

                                      checked={enableTlVerilog}

                                      onChange={(e) => setEnableTlVerilog(e.target.checked)}

                                    />

                                    Enable TL-Verilog

                                  </label>

                                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                    <input

                                      type="checkbox"

                                      checked={enableEasierUvm}

                                      onChange={(e) => setEnableEasierUvm(e.target.checked)}

                                    />

                                    Enable Easier UVM

                                  </label>

                                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer' }}>

                                    <input

                                      type="checkbox"

                                      checked={enableVUnit}

                                      onChange={(e) => setEnableVUnit(e.target.checked)}

                                    />

                                    Enable VUnit

                                  </label>

                                </div>

                              </div>

                            )}

                            {/* General execution checkboxes */}

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>

                              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                                <input

                                  type="checkbox"

                                  checked={useRunBash}

                                  onChange={(e) => setUseRunBash(e.target.checked)}

                                />

                                Use run.bash shell script

                              </label>

                              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                                <input

                                  type="checkbox"

                                  checked={showOutputText}

                                  onChange={(e) => setShowOutputText(e.target.checked)}

                                />

                                Show output text file

                              </label>

                              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                                <input

                                  type="checkbox"

                                  checked={showOutputSvg}

                                  onChange={(e) => setShowOutputSvg(e.target.checked)}

                                />

                                Show output SVG file

                              </label>

                              {showOutputSvg && (

                                <input

                                  type="text"

                                  className={styles.sidebarInput}

                                  style={{ marginTop: '2px', fontSize: '10px' }}

                                  value={outputSvgFilename}

                                  onChange={(e) => setOutputSvgFilename(e.target.value)}

                                  placeholder="Output SVG Filename"

                                />

                              )}

                              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                                <input

                                  type="checkbox"

                                  checked={downloadFiles}

                                  onChange={(e) => setDownloadFiles(e.target.checked)}

                                />

                                Download files after run

                              </label>

                            </div>



                            

                          </div>

                        )}

                      </>

                     </>

                  ) : (

                    <>

                      {/* Top Module Input & Checkbox */}

                      <div className={styles.sidebarSection}>

                        <label className={styles.sidebarLabel}>Top Module</label>

                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>

                          <input

                            type="text"

                            className={styles.sidebarInput}

                            value={lintTopModule}

                            onChange={(e) => setLintTopModule(e.target.value)}

                            placeholder="e.g. my_module"

                          />

                          <label style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '10px', color: '#94a3b8', cursor: 'pointer', whiteSpace: 'nowrap' }}>

                            <input

                              type="checkbox"

                              checked={lintNoTop}

                              onChange={(e) => setLintNoTop(e.target.checked)}

                            />

                            --no-top

                          </label>

                        </div>

                        <div className={styles.sidebarInfoText}>

                          Leave blank to auto-detect, or check <code>--no-top</code> to allow multiple tops

                        </div>

                      </div>



                      {/* Defines / Macros */}

                      <div className={styles.sidebarSection}>

                        <label className={styles.sidebarLabel}>Defines / Macros</label>

                        <input

                          type="text"

                          className={styles.sidebarInput}

                          value={lintDefines}

                          onChange={(e) => setLintDefines(e.target.value)}

                          placeholder="DEBUG=1, WIDTH=8, SYNTH"

                        />

                        <div className={styles.sidebarInfoText}>

                          Sets <code>`ifdef</code> flags. e.g. <code>SIM=1, WIDTH=8, SYNTH</code> → adds <code>-DSIM=1 -DWIDTH=8 -DSYNTH</code>

                        </div>

                      </div>



                      {/* Strictness */}

                      <div className={styles.sidebarSection}>

                        <label className={styles.sidebarLabel}>Strictness</label>

                        <div className={styles.sidebarInputRow}>

                          <div>

                            <div style={{ fontSize: '9px', color: '#64748b', marginBottom: '2px' }}>Error limit</div>

                            <input

                              type="number"

                              className={styles.sidebarInput}

                              value={lintErrorLimit}

                              onChange={(e) => setLintErrorLimit(e.target.value)}

                              placeholder="50"

                            />

                          </div>

                          <div>

                            <div style={{ fontSize: '9px', color: '#64748b', marginBottom: '2px' }}>Warnings as errors</div>

                            <input

                              type="text"

                              className={styles.sidebarInput}

                              value={lintWarningsAsErrors}

                              onChange={(e) => setLintWarningsAsErrors(e.target.value)}

                              placeholder="WIDTH, UNUSED"

                            />

                          </div>

                        </div>

                        <div className={styles.sidebarInfoText}>

                          <strong>Warnings as errors:</strong> treat specific warnings as hard errors. e.g. <code>WIDTH, UNUSED</code> → <code>-Werror-WIDTH -Werror-UNUSED</code>. Leave blank to keep them as warnings only.

                        </div>

                      </div>



                      {/* Additional Args */}

                      <div className={styles.sidebarSection}>

                        <label className={styles.sidebarLabel}>Additional Args</label>

                        <input

                          type="text"

                          className={styles.sidebarInput}

                          value={lintAdditionalArgs}

                          onChange={(e) => setLintAdditionalArgs(e.target.value)}

                          placeholder="-Wall"

                        />

                        <div className={styles.sidebarInfoText}>

                          Raw Verilator flags appended verbatim. Suppress a warning: <code>-Wno-EOFNEWLINE</code>. Enable all warnings: <code>-Wall</code>. Multiple flags space-separated: <code>-Wno-UNUSED -Wno-WIDTH</code>

                        </div>

                      </div>



                      {/* Warning Info card */}

                      <div className={styles.lintAlertCard}>

                        <div className={styles.lintAlertCardHeader}>

                          <span style={{ fontSize: '12px' }}>ℹ</span> Checks for common Verilog coding issues:

                        </div>

                        <ul>

                          <li>Unused signals and variables</li>

                          <li>Undriven or multiply-driven nets</li>

                          <li>Combinational loops</li>

                          <li>Width mismatches</li>

                          <li>Case statement issues</li>

                        </ul>

                      </div>

                    </>

                  )}



                  {/* Quota & Run button */}

                  {/* <div className={styles.quotaStatus} style={{ marginTop: 'auto', paddingTop: '10px' }}>

                    <span>Loading quota...</span>

                    <button className={styles.cacheBtn} onClick={() => alert('Cache cleared successfully.')}>🗑 Cache</button>

                  </div> */}



                  <button 

                    className={styles.runLintBtn} 

                    onClick={runCode}

                    style={{ backgroundColor: selectedTool?.value === 'verilator_lint' ? '#4f46e5' : '#22c55e', marginTop: '10px' }}

                    disabled={isRunningDesign}

                  >

                    {selectedTool?.value === 'verilator_lint' ? <CheckCircle size={14} /> : <Play size={14} />} 

                    {isRunningDesign ? (selectedTool?.value === 'verilator_lint' ? 'Linting...' : 'Simulating...') : (selectedTool?.value === 'verilator_lint' ? 'Run Verilator Lint' : 'Run Simulation')}

                  </button>

                </div>

              )}



              {activeSidebarTab === 'synthesis' && (

                <div className={styles.simulationPanel}>

                  <div className={styles.sidebarPanelTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <Cpu size={14} style={{ color: '#60a5fa' }} /> Logic Synthesis (Yosys)

                  </div>

                  

                  {/* Target Library */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Target Library</label>

                    <select

                      className={styles.sidebarInput}

                      value={selectedSynthTarget}

                      onChange={(e) => setSelectedSynthTarget(e.target.value)}

                    >

                      <option value="sky130">SkyWater 130nm PDK</option>

                      <option value="generic">Gtech Generic Library</option>

                      <option value="standard">Standard Cell Mapping</option>

                    </select>

                  </div>



                  {/* Synthesis Top Module */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Top Module</label>

                    <input

                      type="text"

                      className={styles.sidebarInput}

                      value={synthTopModule}

                      onChange={(e) => setSynthTopModule(e.target.value)}

                      placeholder="e.g. fulladd (autodetect)"

                    />

                  </div>



                  {/* Optimization */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Optimization</label>

                    <select

                      className={styles.sidebarInput}

                      value={synthOptimize}

                      onChange={(e) => setSynthOptimize(e.target.value)}

                    >

                      <option value="-O0">O0 - No optimization</option>

                      <option value="-O1">O1 - Basic synthesis</option>

                      <option value="-O2">O2 - Flatten &amp; Map</option>

                      <option value="-Os">Os - Size optimized</option>

                    </select>

                  </div>



                  {/* ABC Map optimization target */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>ABC Map Target</label>

                    <select

                      className={styles.sidebarInput}

                      value={abcTarget}

                      onChange={(e) => setAbcTarget(e.target.value)}

                    >

                      <option value="balanced">Balanced Area/Delay</option>

                      <option value="area">Optimize for Area</option>

                      <option value="delay">Optimize for Delay (Timing)</option>

                    </select>

                  </div>



                  {/* Synthesis options checkboxes */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Compiler Flags</label>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>

                      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                        <input

                          type="checkbox"

                          checked={synthFlatten}

                          onChange={(e) => setSynthFlatten(e.target.checked)}

                        />

                        Flatten Netlist structure

                      </label>

                      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                        <input

                          type="checkbox"

                          checked={clockGating}

                          onChange={(e) => setClockGating(e.target.checked)}

                        />

                        Enable Clock Gating map

                      </label>

                    </div>

                  </div>



                  {/* Run button */}

                  <button 

                    className={styles.runLintBtn} 

                    onClick={handleRunYosys}

                    style={{ backgroundColor: '#8b5cf6', marginTop: '10px' }}

                    disabled={synthesisLoading}

                  >

                    <Cpu size={14} /> {synthesisLoading ? 'Synthesizing...' : 'Run Yosys Synthesis'}

                  </button>

                </div>

              )}



              {activeSidebarTab === 'timing' && (

                <div className={styles.simulationPanel}>

                  <div className={styles.sidebarPanelTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <Clock size={14} style={{ color: '#60a5fa' }} /> Static Timing Analysis (OpenSTA)

                  </div>



                  {/* Timing Corners */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Timing Corner</label>

                    <select className={styles.sidebarInput} value={timingCorner} onChange={(e) => setTimingCorner(e.target.value)}>

                      <option value="typical">Typical corner (25°C, 1.8V)</option>

                      <option value="fast">Fast corner (-40°C, 1.95V)</option>

                      <option value="slow">Slow corner (125°C, 1.6V)</option>

                      <option value="all">Multi-corner multimode (MCMM)</option>

                    </select>

                  </div>



                  {/* Target Clock Period */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Target Clock Period (ns)</label>

                    <input type="text" className={styles.sidebarInput} value={clockPeriod} onChange={(e) => setClockPeriod(e.target.value)} placeholder="10.0" />

                  </div>



                  {/* SDC Constraints File */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>SDC Constraints File</label>

                    <select className={styles.sidebarInput} value={sdcFile} onChange={(e) => setSdcFile(e.target.value)}>

                      <option value="autodetect">Autodetect (.sdc)</option>

                      <option value="none">No constraint file</option>

                    </select>

                  </div>



                  {/* Max Transition & Cap side-by-side */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Design Constraints</label>

                    <div className={styles.sidebarInputRow}>

                      <div>

                        <div style={{ fontSize: '9px', color: '#64748b', marginBottom: '2px' }}>Max Trans (ns)</div>

                        <input type="text" className={styles.sidebarInput} value={maxTransition} onChange={(e) => setMaxTransition(e.target.value)} placeholder="0.5" />

                      </div>

                      <div>

                        <div style={{ fontSize: '9px', color: '#64748b', marginBottom: '2px' }}>Max Cap (fF)</div>

                        <input type="text" className={styles.sidebarInput} value={maxCapacitance} onChange={(e) => setMaxCapacitance(e.target.value)} placeholder="50.0" />

                      </div>

                    </div>

                  </div>



                  {/* Slack checks toggle */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>

                      <input type="checkbox" checked={timingOptimize} onChange={(e) => setTimingOptimize(e.target.checked)} />

                      Analyze setup &amp; hold violations

                    </label>

                  </div>



                  <button className={styles.runLintBtn} onClick={handleRunPpa} style={{ backgroundColor: '#0284c7', marginTop: '10px' }} disabled={ppaLoading}>

                    <Clock size={14} /> {ppaLoading ? 'Running STA...' : 'Run Static Timing Analysis'}

                  </button>

                </div>

              )}



              {activeSidebarTab === 'ppa' && (

                <div className={styles.simulationPanel}>

                  <div className={styles.sidebarPanelTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <Sliders size={14} style={{ color: '#a78bfa' }} /> Power, Performance &amp; Area (PPA)

                  </div>



                  {/* Cell Library */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Standard Cell Library</label>

                    <select className={styles.sidebarInput} value={ppaCellLibrary} onChange={(e) => setPpaCellLibrary(e.target.value)}>

                      <option value="sky130_fd_sc_hd">SkyWater 130nm HD Library</option>

                      <option value="sky130_fd_sc_hs">SkyWater 130nm HS Library</option>

                      <option value="osu120">OSU 0.18um cell library</option>

                    </select>

                  </div>



                  {/* PVT parameters */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>PVT Settings</label>

                    <div className={styles.sidebarInputRow}>

                      <div>

                        <div style={{ fontSize: '9px', color: '#64748b', marginBottom: '2px' }}>Temp (°C)</div>

                        <input type="text" className={styles.sidebarInput} value={ppaTemperature} onChange={(e) => setPpaTemperature(e.target.value)} placeholder="25" />

                      </div>

                      <div>

                        <div style={{ fontSize: '9px', color: '#64748b', marginBottom: '2px' }}>Voltage (V)</div>

                        <input type="text" className={styles.sidebarInput} value={ppaVoltage} onChange={(e) => setPpaVoltage(e.target.value)} placeholder="1.8" />

                      </div>

                    </div>

                  </div>



                  {/* Max Load Capacitance */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Max Load Capacitance (fF)</label>

                    <input type="text" className={styles.sidebarInput} value={ppaCapacitance} onChange={(e) => setPpaCapacitance(e.target.value)} placeholder="10.0" />

                  </div>



                  <button className={styles.runLintBtn} onClick={handleRunPpaReport} style={{ backgroundColor: '#7c3aed', marginTop: '10px' }} disabled={ppaLoading}>

                    <Sliders size={14} /> {ppaLoading ? 'Generating Report...' : 'Run PPA Report'}

                  </button>

                </div>

              )}



              {activeSidebarTab === 'pnr' && (

                <div className={styles.simulationPanel}>

                  <div className={styles.sidebarPanelTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <Layers size={14} style={{ color: '#60a5fa' }} /> Place &amp; Route (OpenROAD)

                  </div>

                  

                  {/* Floorplan size configs */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Floorplan sizing</label>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>

                      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                        <input

                          type="checkbox"

                          checked={pnrAutoDie}

                          onChange={(e) => setPnrAutoDie(e.target.checked)}

                        />

                        Calculate die size automatically

                      </label>

                    </div>

                  </div>



                  {/* Core Utilization */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Core Utilization (%)</label>

                    <input

                      type="number"

                      className={styles.sidebarInput}

                      value={coreUtilization}

                      onChange={(e) => setCoreUtilization(e.target.value)}

                      min="10"

                      max="90"

                      placeholder="40"

                    />

                  </div>



                  {/* Aspect Ratio */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Aspect Ratio (W/H)</label>

                    <input

                      type="text"

                      className={styles.sidebarInput}

                      value={pnrAspectRatio}

                      onChange={(e) => setPnrAspectRatio(e.target.value)}

                      placeholder="1.0"

                    />

                  </div>



                  {/* Pin Placement */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Pin Placement</label>

                    <select

                      className={styles.sidebarInput}

                      value={pinPlacement}

                      onChange={(e) => setPinPlacement(e.target.value)}

                    >

                      <option value="side">Edge-aligned placement</option>

                      <option value="random">Random placement</option>

                      <option value="spread">Even spread placement</option>

                    </select>

                  </div>



                  {/* Clock Tree Synthesis */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>CTS Optimization</label>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>

                      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer' }}>

                        <input

                          type="checkbox"

                          checked={pnrCts}

                          onChange={(e) => setPnrCts(e.target.checked)}

                        />

                        Enable Clock Tree Synthesis (CTS)

                      </label>

                    </div>

                  </div>



                  {/* Export Format */}

                  <div className={styles.sidebarSection}>

                    <label className={styles.sidebarLabel}>Export Format</label>

                    <select

                      className={styles.sidebarInput}

                      value={pnrExportFormat}

                      onChange={(e) => setPnrExportFormat(e.target.value)}

                    >

                      <option value="gds">GDSII format (production)</option>

                      <option value="lef">LEF format (abstract)</option>

                      <option value="def">DEF format (design)</option>

                    </select>

                  </div>



                  {/* Run button */}

                  <button 

                    className={styles.runLintBtn} 

                    onClick={handleRunPnR}

                    style={{ backgroundColor: '#10b981', marginTop: '10px' }}

                    disabled={pnrLoading}

                  >

                    <Layers size={14} /> {pnrLoading ? 'Routing...' : 'Run Place & Route'}

                  </button>

                </div>

              )}

             





              {activeSidebarTab === 'settings' && (

                <div className={styles.settingsPanel}>

                  <div className={styles.sidebarPanelTitle}>Settings</div>

                  <div style={{ padding: '0.75rem', fontSize: '12px', color: '#94a3b8' }}>

                    <div style={{ marginBottom: '1rem' }}>

                      <label style={{ display: 'block', marginBottom: '4px' }}>Theme</label>

                      <select 

                        className={styles.sidebarInput} 

                        value={theme}

                        onChange={(e) => {

                          const val = e.target.value;

                          setTheme(val);

                        }}

                      >

                        <option value="dark">SkyWater Dark</option>

                        <option value="light">CVS Light</option>

                      </select>

                    </div>

                    <div style={{ marginBottom: '1rem' }}>

                      <label style={{ display: 'block', marginBottom: '4px' }}>Tab Size</label>

                      <input type="number" className={styles.sidebarInput} defaultValue={2} />

                    </div>

                    <div style={{ marginBottom: '1.5rem' }}>

                      <label style={{ display: 'block', marginBottom: '4px' }}>Minimap</label>

                      <input type="checkbox" defaultChecked /> Enable

                    </div>



                    {/* Collapsible resources drawer */}

                    <div className={styles.drawerHeader} onClick={() => setResourcesOpen(!resourcesOpen)} style={{ marginTop: '16px' }}>

                      <span>RESOURCES</span>

                      <span>{resourcesOpen ? '▾' : '▸'}</span>

                    </div>

                    {resourcesOpen && (

                      <div className={styles.drawerContent} style={{ marginBottom: '1rem' }}>

                        • SkyWater 130nm standard cells loaded<br/>

                        • 45nm predictive gate libraries loaded

                      </div>

                    )}



                    {/* Collapsible advanced drawer */}

                    <div className={styles.drawerHeader} onClick={() => setAdvancedOpen(!advancedOpen)}>

                      <span>ADVANCED</span>

                      <span>{advancedOpen ? '▾' : '▸'}</span>

                    </div>

                    {advancedOpen && (

                      <div className={styles.drawerContent}>

                        • Compilation timeout: dynamic (60s/120s)<br/>

                        • Output buffering: enabled<br/>

                        • Optimization level: O2

                      </div>

                    )}

                  </div>

                </div>

              )}



              {activeSidebarTab === 'ai' && (

                <div className={styles.aiPanel}>

                  <div className={styles.sidebarPanelTitle}>🤖 AI Helper</div>

                  <div className={styles.chatHistory} ref={chatHistoryRef}>

                    {chatMessages.map((msg, idx) => (

                      <div key={idx} className={`${styles.chatBubble} ${msg.sender === 'user' ? styles.userBubble : styles.aiBubble}`}>

                        <div className={styles.chatBubbleHeader}>

                          {msg.sender === 'user' ? 'You' : 'Silicon AI'}

                        </div>

                        <div className={styles.chatBubbleText}>

                          {msg.text}

                        </div>

                      </div>

                    ))}

                    {isAiTyping && (

                      <div className={`${styles.chatBubble} ${styles.aiBubble}`}>

                        <div className={styles.chatBubbleHeader}>Silicon AI</div>

                        <div className={styles.typingIndicator}>

                          <span></span><span></span><span></span>

                        </div>

                      </div>

                    )}

                  </div>

                  <div className={styles.chatInputContainer}>

                    <textarea

                      className={styles.chatInput}

                      placeholder="Ask AI about Verilog..."

                      value={aiInput}

                      onChange={(e) => setAiInput(e.target.value)}

                      onKeyDown={(e) => {

                        if (e.key === 'Enter' && !e.shiftKey) {

                          e.preventDefault();

                          handleSendAiMessage();

                        }

                      }}

                    />

                    <button className={styles.chatSendBtn} onClick={handleSendAiMessage}>

                      Send

                    </button>

                  </div>

                </div>

              )}

            </div>

          )}



          {/* Right Workspace - Editor & Console Split */}

          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>

            

            {/* Editor Frame (Top half) */}

            <div style={isConsoleMaximized ? { flex: '0 0 auto', display: 'flex', flexDirection: 'column', position: 'relative' } : { flex: 1, display: 'flex', flexDirection: 'column', minHeight: '0', position: 'relative' }}>

              

              {/* Editor Tabs bar */}
              <div style={{ height: '34px', backgroundColor: 'var(--tab-inactive-bg)', borderBottom: '1px solid var(--border-color)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: '8px', userSelect: 'none' }}>
                {/* Left: Open File Tabs */}
                <div style={{ display: 'flex', alignItems: 'center', overflowX: 'auto', flex: 1, height: '100%', scrollbarWidth: 'none' }}>
                  {openTabIds.map(tabId => {
                    const file = files.find(f => f.id === tabId);
                    if (!file) return null;
                    const isTabActive = tabId === activeFileId;
                    const ext = file.name.substring(file.name.lastIndexOf('.'));
                    const extColors = {
                      '.v': '#06b6d4',
                      '.sv': '#a855f7',
                      '.vhd': '#f97316',
                      '.vhdl': '#f97316',
                      '.sdc': '#eab308',
                      '.py': '#3b82f6',
                      '.c': '#64748b'
                    };
                    const dotColor = extColors[ext] || '#94a3b8';

                    return (
                      <div
                        key={tabId}
                        onClick={() => handleSelectFile(tabId)}
                        style={{
                          padding: '0 10px',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          borderRight: '1px solid var(--border-color)',
                          backgroundColor: isTabActive ? 'var(--tab-active-bg)' : 'var(--tab-inactive-bg)',
                          borderTop: isTabActive ? '2px solid var(--tab-active-border)' : '2px solid transparent',
                          cursor: 'pointer',
                          fontSize: '12px',
                          color: isTabActive ? 'var(--text-main)' : 'var(--text-muted)',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: dotColor, flexShrink: 0 }}></span>
                        <span>{file.name}</span>
                        {file.isDirty && (
                          <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#f97316', flexShrink: 0 }} title="Unsaved changes"></span>
                        )}
                        <span 
                          onClick={(e) => handleCloseTab(e, tabId)}
                          style={{ fontSize: '13px', color: 'var(--text-muted)', cursor: 'pointer', display: 'inline-flex', padding: '1px 3px', borderRadius: '3px' }}
                          onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'}
                          onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}
                          title="Close tab"
                        >
                          ×
                        </span>
                      </div>
                    );
                  })}
                  {/* Plus button to add a file */}
                  <div
                    onClick={() => setShowNewFileModal(true)}
                    style={{
                      height: '100%',
                      padding: '0 8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      color: '#64748b',
                      borderRight: '1px solid var(--border-color)'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#e2e8f0'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                    title="New File (+)"
                  >
                    <Plus size={13} />
                  </div>
                </div>

                {/* Right: Hardware Action Controls */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, paddingLeft: '8px' }}>
                  
                  {/* Top Module Badge */}
                  <div style={{ position: 'relative' }}>
                    <button
                      onClick={() => setShowTopDropdown(prev => !prev)}
                      style={{
                        height: '22px',
                        padding: '0 6px',
                        fontSize: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        borderRadius: '4px',
                        backgroundColor: 'rgba(6, 182, 212, 0.12)',
                        border: '1px solid rgba(6, 182, 212, 0.3)',
                        color: '#38bdf8',
                        cursor: 'pointer',
                        fontWeight: '600'
                      }}
                      title="Active Top Design Module"
                    >
                      <span style={{ color: '#94a3b8', fontWeight: '400' }}>Top:</span>
                      <span style={{ maxWidth: '75px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {topModule || 'auto'}
                      </span>
                      <ChevronDown size={10} />
                    </button>
                    {showTopDropdown && (
                      <div style={{
                        position: 'absolute',
                        top: '26px',
                        right: 0,
                        zIndex: 100,
                        backgroundColor: '#0f172a',
                        border: '1px solid #334155',
                        borderRadius: '6px',
                        padding: '4px',
                        minWidth: '160px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.5)'
                      }}>
                        <div style={{ padding: '4px 8px', fontSize: '10px', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>
                          Select Top Module
                        </div>
                        <div 
                          onClick={() => { setTopModule(''); setShowTopDropdown(false); }}
                          style={{
                            padding: '4px 8px',
                            fontSize: '11px',
                            color: !topModule ? '#38bdf8' : '#e2e8f0',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            backgroundColor: !topModule ? 'rgba(6,182,212,0.15)' : 'transparent'
                          }}
                        >
                          Auto-detect
                        </div>
                        {getAllModulesFromFiles().filter(m => !m.name.startsWith('tb_')).map(m => (
                          <div
                            key={m.name}
                            onClick={() => { setTopModule(m.name); setShowTopDropdown(false); }}
                            style={{
                              padding: '4px 8px',
                              fontSize: '11px',
                              color: topModule === m.name ? '#38bdf8' : '#e2e8f0',
                              cursor: 'pointer',
                              borderRadius: '4px',
                              backgroundColor: topModule === m.name ? 'rgba(6,182,212,0.15)' : 'transparent',
                              display: 'flex',
                              justifyContent: 'space-between'
                            }}
                          >
                            <span>{m.name}</span>
                            <span style={{ fontSize: '10px', color: '#64748b' }}>{m.fileName}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* TB Module Badge */}
                  <div style={{ position: 'relative' }}>
                    <button
                      onClick={() => setShowTbDropdown(prev => !prev)}
                      style={{
                        height: '22px',
                        padding: '0 6px',
                        fontSize: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        borderRadius: '4px',
                        backgroundColor: 'rgba(168, 85, 247, 0.12)',
                        border: '1px solid rgba(168, 85, 247, 0.3)',
                        color: '#c084fc',
                        cursor: 'pointer',
                        fontWeight: '600'
                      }}
                      title="Active Testbench Target"
                    >
                      <span style={{ color: '#94a3b8', fontWeight: '400' }}>TB:</span>
                      <span style={{ maxWidth: '75px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {testbenchModule || 'auto'}
                      </span>
                      <ChevronDown size={10} />
                    </button>
                    {showTbDropdown && (
                      <div style={{
                        position: 'absolute',
                        top: '26px',
                        right: 0,
                        zIndex: 100,
                        backgroundColor: '#0f172a',
                        border: '1px solid #334155',
                        borderRadius: '6px',
                        padding: '4px',
                        minWidth: '160px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.5)'
                      }}>
                        <div style={{ padding: '4px 8px', fontSize: '10px', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>
                          Select Testbench
                        </div>
                        <div 
                          onClick={() => { setTestbenchModule(''); setShowTbDropdown(false); }}
                          style={{
                            padding: '4px 8px',
                            fontSize: '11px',
                            color: !testbenchModule ? '#c084fc' : '#e2e8f0',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            backgroundColor: !testbenchModule ? 'rgba(168,85,247,0.15)' : 'transparent'
                          }}
                        >
                          Auto-detect
                        </div>
                        {getAllModulesFromFiles().map(m => (
                          <div
                            key={m.name}
                            onClick={() => { setTestbenchModule(m.name); setShowTbDropdown(false); }}
                            style={{
                              padding: '4px 8px',
                              fontSize: '11px',
                              color: testbenchModule === m.name ? '#c084fc' : '#e2e8f0',
                              cursor: 'pointer',
                              borderRadius: '4px',
                              backgroundColor: testbenchModule === m.name ? 'rgba(168,85,247,0.15)' : 'transparent',
                              display: 'flex',
                              justifyContent: 'space-between'
                            }}
                          >
                            <span>{m.name}</span>
                            <span style={{ fontSize: '10px', color: '#64748b' }}>{m.fileName}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* HDL Snippets Dropdown */}
                  <div style={{ position: 'relative' }}>
                    <button
                      onClick={() => setShowSnippetsDropdown(prev => !prev)}
                      style={{
                        height: '22px',
                        padding: '0 7px',
                        fontSize: '11px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        borderRadius: '4px',
                        backgroundColor: 'rgba(234, 179, 8, 0.12)',
                        border: '1px solid rgba(234, 179, 8, 0.3)',
                        color: '#facc15',
                        cursor: 'pointer',
                        fontWeight: '500'
                      }}
                      title="Insert HDL Templates & Auto-generate Testbench"
                    >
                      <Code size={11} />
                      HDL Snippets
                      <ChevronDown size={10} />
                    </button>
                    {showSnippetsDropdown && (
                      <div style={{
                        position: 'absolute',
                        top: '26px',
                        right: 0,
                        zIndex: 100,
                        backgroundColor: '#0f172a',
                        border: '1px solid #334155',
                        borderRadius: '6px',
                        padding: '6px',
                        width: '280px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.6)'
                      }}>
                        {/* Auto TB Generator */}
                        <div
                          onClick={() => {
                            handleGenerateTestbench();
                          }}
                          style={{
                            padding: '6px 10px',
                            borderRadius: '4px',
                            backgroundColor: 'rgba(56, 189, 248, 0.12)',
                            border: '1px solid rgba(56, 189, 248, 0.3)',
                            cursor: 'pointer',
                            marginBottom: '6px'
                          }}
                        >
                          <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#38bdf8', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <Zap size={11} fill="#38bdf8" /> Auto-Generate Testbench
                          </div>
                          <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>
                            Scans active module & creates tb_*.v with clock & stimulus
                          </div>
                        </div>

                        <div style={{ height: '1px', backgroundColor: '#334155', margin: '4px 0' }} />

                        {HDL_SNIPPETS.map((snip, idx) => (
                          <div
                            key={idx}
                            onClick={() => handleInsertSnippet(snip.code)}
                            style={{
                              padding: '5px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              transition: 'background-color 0.15s',
                              marginBottom: '2px'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1e293b'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ fontSize: '11px', fontWeight: '600', color: '#f1f5f9' }}>{snip.name}</span>
                              <span style={{ fontSize: '9px', padding: '1px 5px', borderRadius: '4px', backgroundColor: '#1e293b', color: '#94a3b8' }}>
                                {snip.category}
                              </span>
                            </div>
                            <div style={{ fontSize: '10px', color: '#64748b' }}>{snip.desc}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Theme selector */}
                  <select
                    value={editorTheme}
                    onChange={(e) => setEditorTheme(e.target.value)}
                    style={{
                      height: '22px',
                      padding: '0 4px',
                      fontSize: '11px',
                      borderRadius: '4px',
                      backgroundColor: '#1e293b',
                      border: '1px solid #334155',
                      color: '#cbd5e1',
                      cursor: 'pointer'
                    }}
                    title="Monaco Editor EDA Theme"
                  >
                    <option value="silicon-dark">Silicon Dark</option>
                    <option value="obsidian-chip">Obsidian Chip</option>
                    <option value="solarized-lab">Solarized Lab</option>
                    <option value="clean-paper">Clean Paper</option>
                  </select>

                  {/* Word Wrap toggle */}
                  <button
                    onClick={() => setIsWordWrap(prev => !prev)}
                    style={{
                      height: '22px',
                      padding: '0 6px',
                      fontSize: '11px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      borderRadius: '4px',
                      backgroundColor: isWordWrap ? 'rgba(56, 189, 248, 0.2)' : '#1e293b',
                      border: isWordWrap ? '1px solid #38bdf8' : '1px solid #334155',
                      color: isWordWrap ? '#38bdf8' : '#94a3b8',
                      cursor: 'pointer'
                    }}
                    title="Toggle Word Wrap (Alt+Z)"
                  >
                    <AlignLeft size={11} />
                  </button>

                  {/* Run Code Button */}
                  <button
                    className={`${styles.headerRunBtn} ${isRunningDesign ? styles.disabled : ''}`}
                    onClick={handleMainRun}
                    disabled={isRunningDesign}
                    style={{
                      height: '22px',
                      padding: '0 10px',
                      fontSize: '11px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      borderRadius: '4px',
                      backgroundColor: isRunningDesign ? '#4b5563' : 'var(--primary-color)',
                      color: '#ffffff',
                      border: 'none',
                      cursor: isRunningDesign ? 'not-allowed' : 'pointer',
                      fontWeight: '500',
                      transition: 'background-color 0.2s',
                      margin: 0
                    }}
                    title="Run Simulation (Ctrl+Enter / F5)"
                  >
                    <Play size={10} fill="#ffffff" style={{ display: 'inline' }} />
                    {isRunningDesign ? 'Running...' : 'Run Code'}
                  </button>
                </div>
              </div>
              
{/* Monaco Editor instance */}

              {!isConsoleMaximized && (

                <div className={styles.editorContainer} style={{ flex: 1 }}>

                  {activeFileId && files.some(f => f.id === activeFileId) ? (

                    <Editor

                      height="100%"

                      language={files.find(f => f.id === activeFileId)?.monaco || 'verilog'}

                      value={code}

                      onChange={(val) => {

                        const next = val || '';

                        setCode(next);

                        setFiles(prev => prev.map(f => f.id === activeFileId ? { ...f, content: next, isDirty: true } : f));

                        setAutosaveStatus('dirty');

                      }}

                      onMount={handleEditorMount}

                      theme={theme === 'light' ? 'clean-paper' : editorTheme}
                      options={{
                        minimap: { enabled: false },
                        fontSize: 14,
                        lineNumbers: 'on',
                        fontFamily: "'Fira Code', monospace",
                        automaticLayout: true,
                        wordWrap: isWordWrap ? 'on' : 'off'
                      }}

                    />

                  ) : (

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#64748b' }}>

                      Select a file from the workspace explorer to start editing

                    </div>

                  )}

                </div>

              )}



            </div>



            {/* Resize Splitter Divider */}

            {!isConsoleMaximized && (

              <div 

                style={{ height: '4px', background: '#1e293b', cursor: 'row-resize', transition: 'background 0.2s' }} 

                onMouseDown={handleConsoleResizeMouseDown}

                onMouseEnter={(e) => e.target.style.background = '#3b82f6'}

                onMouseLeave={(e) => e.target.style.background = '#1e293b'}

                onDoubleClick={() => setConsoleHeight('25%')}

                title="Drag to resize, double-click to reset to 25%"

              ></div>

            )}



            {/* Results panel (Bottom half) */}

            <div style={{ height: isConsoleMaximized ? '100%' : (typeof consoleHeight === 'number' ? `${consoleHeight}px` : consoleHeight), minHeight: isConsoleMaximized ? '100%' : '100px', display: 'flex', flexDirection: 'column', backgroundColor: 'var(--console-bg)', borderTop: isConsoleMaximized ? 'none' : '1px solid var(--border-color)', flexShrink: 0 }}>

              

              {/* Output tabs bar */}

              <div style={{ height: '32px', backgroundColor: 'var(--tab-inactive-bg)', borderBottom: '1px solid var(--border-color)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                <div style={{ display: 'flex', height: '100%' }}>

                  {['output', 'waveform', 'schematic', 'timing', 'ppa', 'pnr', ...(coverageEnabled ? ['coverage'] : [])].map(tab => (

                    <button

                      key={tab}

                      onClick={() => setActiveResultTab(tab)}

                      style={{

                        padding: '0 16px',

                        height: '100%',

                        border: 'none',

                        background: activeResultTab === tab ? 'var(--console-bg)' : 'var(--tab-inactive-bg)',

                        color: activeResultTab === tab ? 'var(--tab-active-border)' : 'var(--text-muted)',

                        fontSize: '11px',

                        fontWeight: 'bold',

                        textTransform: 'uppercase',

                        borderTop: activeResultTab === tab ? '2px solid var(--tab-active-border)' : '2px solid transparent',

                        cursor: 'pointer'

                      }}

                    >

                      {tab === 'pnr' ? 'PnR Layout' : tab === 'timing' ? 'Timing Paths' : tab === 'ppa' ? 'PPA Report' : tab === 'coverage' ? 'Code Coverage' : tab}

                    </button>

                  ))}

                </div>

                <div style={{ paddingRight: '12px', display: 'flex', alignItems: 'center', gap: '12px' }}>

                  <button 

                    onClick={() => setOutput('')}

                    style={{ background: 'transparent', border: 'none', color: '#475569', cursor: 'pointer', fontSize: '10px' }}

                    title="Clear Console"

                  >

                    Clear Logs

                  </button>

                  <button 

                    onClick={() => setIsConsoleMaximized(prev => !prev)}

                    style={{ background: 'transparent', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', transition: 'color 0.2s' }}

                    onMouseEnter={(e) => e.target.style.color = '#fff'}

                    onMouseLeave={(e) => e.target.style.color = '#64748b'}

                    title={isConsoleMaximized ? "Restore Panel Size" : "Maximize Panel Size"}

                  >

                    {isConsoleMaximized ? '🗗' : '🗖'}

                  </button>

                </div>

              </div>



              {/* Tab contents */}

              <div style={{ flex: 1, minHeight: '0', overflow: 'hidden' }}>

                {activeResultTab === 'output' && (

                  <div className={styles.output}>

                    <div className={styles.outputContent} style={{ whiteSpace: 'pre-wrap' }}>

                      {renderOutputConsole(output)}

                    </div>

                  </div>

                )}

                {activeResultTab === 'waveform' && (

                  <div className={styles.waveformContainer} style={{ height: '100%', overflow: 'hidden' }}>

                    {vcdLoading ? (

                      <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-muted)' }}>

                        Fetching waveform data...

                      </div>

                    ) : (

                      <WaveformViewer 

                        vcdContent={vcdContent} 

                        theme={theme} 

                        viewerType={waveDumping === 'epwave' ? 'EPWave' : (waveDumping === 'fst' ? 'FST Viewer' : 'Surfer Viewer')}

                        formatType={waveDumping === 'fst' ? 'FST' : 'VCD'}

                      />

                    )}

                  </div>

                )}

                {activeResultTab === 'schematic' && (

                  synthesisLoading ? (

                    <div className={styles.toolInfoPane}>

                      <div className={styles.toolSpinner} />

                      <strong>Running Yosys Synthesis...</strong>

                      <p>Synthesizing your Verilog design. The interactive logic schematic will appear here once complete.</p>

                    </div>

                  ) : synthesisDone ? (

                    <SchematicViewer

                      theme={theme}

                      problemTitle={activeProjectTitle}

                      parsedGraph={yosysNetlist}

                    />

                  ) : (

                    <div className={styles.toolInfoPane}>

                      <span style={{ fontSize: '28px' }}>🔌</span>

                      <strong>Logic Schematic Not Generated</strong>

                      <p>Open the <strong>Logic Synthesis</strong> panel in the sidebar and click <strong>Run Yosys Synthesis</strong> to generate an interactive gate-level schematic.</p>

                    </div>

                  )

                )}

                {activeResultTab === 'pnr' && (

                  pnrLoading ? (

                    <div className={styles.toolInfoPane}>

                      <div className={styles.toolSpinner} />

                      <strong>Running OpenROAD Place &amp; Route...</strong>

                      <p>Placing and routing your synthesized netlist. The physical cell layout will appear here once complete.</p>

                    </div>

                  ) : pnrDone ? (

                    <PnRVisualizer theme={theme} parsedGraph={yosysNetlist} />

                  ) : (

                    <div className={styles.toolInfoPane}>

                      <span style={{ fontSize: '28px' }}>📐</span>

                      <strong>Place &amp; Route Visualizer Not Available</strong>

                      <p>Open the <strong>Place &amp; Route</strong> panel in the sidebar and click <strong>Run OpenROAD PnR</strong> to view physical cell placement rows and routing layers.</p>

                    </div>

                  )

                )}

                {activeResultTab === 'timing' && (

                  ppaLoading ? (

                    <div className={styles.toolInfoPane}>

                      <div className={styles.toolSpinner} />

                      <strong>Running Static Timing Analysis...</strong>

                      <p>OpenSTA is tracing critical paths through your netlist. Timing path results will appear here once complete.</p>

                    </div>

                  ) : ppaReportData ? (

                    <TimingAnalyzer theme={theme} parsedGraph={yosysNetlist} />

                  ) : (

                    <div className={styles.toolInfoPane}>

                      <span style={{ fontSize: '28px' }}>⚡</span>

                      <strong>Static Timing Analysis Not Available</strong>

                      <p>Open the <strong>Static Timing Analysis</strong> panel in the sidebar and click <strong>Run Static Timing Analysis</strong> to compute critical paths, slack, and Fmax.</p>

                    </div>

                  )

                )}

                {activeResultTab === 'ppa' && (

                  ppaLoading ? (

                    <div className={styles.toolInfoPane}>

                      <div className={styles.toolSpinner} />

                      <strong>Generating PPA Report...</strong>

                      <p>OpenSTA is computing power, performance, and area metrics. Your report will appear here once complete.</p>

                    </div>

                  ) : ppaReportData ? (

                    <div style={{ padding: '20px', overflowY: 'auto', height: '100%', color: 'var(--text-main)', scrollbarWidth: 'thin' }}>

                      <h3 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '16px', color: 'var(--primary-color)', borderBottom: '1px solid var(--border-color)', paddingBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>

                        📊 OpenSTA Sign-Off Power, Performance &amp; Area (PPA) Report

                      </h3>

                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>

                        {/* Performance Panel */}

                        <div style={{ background: 'var(--tab-inactive-bg)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '14px' }}>

                          <h4 style={{ fontSize: '11px', fontWeight: 'bold', color: '#10b981', display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>⚡ PERFORMANCE (TIMING)</h4>

                          <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'collapse' }}>

                            <tbody>

                              <tr style={{ borderBottom: '1px solid var(--border-color)' }}>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Worst Negative Slack (WNS)</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold', color: '#10b981' }}>{ppaReportData.timing.wns} ns (MET)</td>

                              </tr>

                              <tr style={{ borderBottom: '1px solid var(--border-color)' }}>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Total Negative Slack (TNS)</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ppaReportData.timing.tns} ns</td>

                              </tr>

                              <tr>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Max Frequency (Fmax)</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold', color: 'var(--primary-color)' }}>{ppaReportData.timing.fmax} MHz</td>

                              </tr>

                            </tbody>

                          </table>

                        </div>

                        {/* Power Panel */}

                        <div style={{ background: 'var(--tab-inactive-bg)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '14px' }}>

                          <h4 style={{ fontSize: '11px', fontWeight: 'bold', color: '#f59e0b', display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>🔋 POWER DISSIPATION</h4>

                          <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'collapse' }}>

                            <tbody>

                              <tr style={{ borderBottom: '1px solid var(--border-color)' }}>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Internal Power</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ppaReportData.power.internal} uW</td>

                              </tr>

                              <tr style={{ borderBottom: '1px solid var(--border-color)' }}>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Switching Power</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ppaReportData.power.switching} uW</td>

                              </tr>

                              <tr style={{ borderBottom: '1px solid var(--border-color)' }}>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Leakage Power</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ppaReportData.power.leakage} uW</td>

                              </tr>

                              <tr style={{ fontWeight: 'bold', color: '#f59e0b' }}>

                                <td style={{ padding: '6px 0' }}>Total Dynamic Power</td>

                                <td style={{ textAlign: 'right' }}>{ppaReportData.power.total} uW</td>

                              </tr>

                            </tbody>

                          </table>

                        </div>

                        {/* Area Panel */}

                        <div style={{ background: 'var(--tab-inactive-bg)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '14px' }}>

                          <h4 style={{ fontSize: '11px', fontWeight: 'bold', color: '#8b5cf6', display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>📐 PHYSICAL AREA</h4>

                          <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'collapse' }}>

                            <tbody>

                              <tr style={{ borderBottom: '1px solid var(--border-color)' }}>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Gate / Cell Area</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ppaReportData.area.total} um²</td>

                              </tr>

                              <tr style={{ borderBottom: '1px solid var(--border-color)' }}>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Standard Cell Count</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ppaReportData.area.cells} cells</td>

                              </tr>

                              <tr>

                                <td style={{ padding: '6px 0', color: 'var(--text-muted)' }}>Core Utilization</td>

                                <td style={{ textAlign: 'right', fontWeight: 'bold', color: '#8b5cf6' }}>{ppaReportData.area.util}%</td>

                              </tr>

                            </tbody>

                          </table>

                        </div>

                      </div>

                    </div>

                  ) : (

                    <div className={styles.toolInfoPane}>

                      <span style={{ fontSize: '28px' }}>📊</span>

                      <strong>PPA Report Not Available</strong>

                      <p>Open the <strong>Power, Performance &amp; Area</strong> panel in the sidebar and click <strong>Run PPA Report</strong> to compute power, Fmax, and physical area metrics.</p>

                    </div>

                  )

                )}

                {activeResultTab === 'coverage' && (

                  coverageReportData ? (

                    <div style={{ padding: '20px', overflowY: 'auto', height: '100%', color: 'var(--text-main)', scrollbarWidth: 'thin' }}>

                      <h3 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '16px', color: 'var(--primary-color)', borderBottom: '1px solid var(--border-color)', paddingBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>

                        🛡️ Code Coverage Analysis Report ({coverageTool.toUpperCase()})

                      </h3>

                      

                      {/* Visual scorecards */}

                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '20px' }}>

                        {coverageReportData.line !== null && (

                          <div style={{ background: 'var(--tab-inactive-bg)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '14px' }}>

                            <div style={{ fontSize: '10px', color: 'var(--text-muted)', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '6px' }}>Statement / Line Coverage</div>

                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#10b981', marginBottom: '8px' }}>{coverageReportData.line.toFixed(2)}%</div>

                            <div style={{ width: '100%', height: '6px', background: '#334155', borderRadius: '3px', overflow: 'hidden' }}>

                              <div style={{ width: `${Math.min(100, coverageReportData.line)}%`, height: '100%', background: '#10b981' }}></div>

                            </div>

                          </div>

                        )}

                        {coverageReportData.toggle !== null && (

                          <div style={{ background: 'var(--tab-inactive-bg)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '14px' }}>

                            <div style={{ fontSize: '10px', color: 'var(--text-muted)', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '6px' }}>Toggle / Port Coverage</div>

                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#3b82f6', marginBottom: '8px' }}>{coverageReportData.toggle.toFixed(2)}%</div>

                            <div style={{ width: '100%', height: '6px', background: '#334155', borderRadius: '3px', overflow: 'hidden' }}>

                              <div style={{ width: `${Math.min(100, coverageReportData.toggle)}%`, height: '100%', background: '#3b82f6' }}></div>

                            </div>

                          </div>

                        )}

                        {coverageReportData.branch !== null && (

                          <div style={{ background: 'var(--tab-inactive-bg)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '14px' }}>

                            <div style={{ fontSize: '10px', color: 'var(--text-muted)', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '6px' }}>Branch / Combinational Coverage</div>

                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#f59e0b', marginBottom: '8px' }}>{coverageReportData.branch.toFixed(2)}%</div>

                            <div style={{ width: '100%', height: '6px', background: '#334155', borderRadius: '3px', overflow: 'hidden' }}>

                              <div style={{ width: `${Math.min(100, coverageReportData.branch)}%`, height: '100%', background: '#f59e0b' }}></div>

                            </div>

                          </div>

                        )}

                        {coverageReportData.fsm !== null && (

                          <div style={{ background: 'var(--tab-inactive-bg)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '14px' }}>

                            <div style={{ fontSize: '10px', color: 'var(--text-muted)', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '6px' }}>FSM Coverage</div>

                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#a78bfa', marginBottom: '8px' }}>{coverageReportData.fsm.toFixed(2)}%</div>

                            <div style={{ width: '100%', height: '6px', background: '#334155', borderRadius: '3px', overflow: 'hidden' }}>

                              <div style={{ width: `${Math.min(100, coverageReportData.fsm)}%`, height: '100%', background: '#a78bfa' }}></div>

                            </div>

                          </div>

                        )}

                      </div>



                      {/* Raw report output */}

                      <div style={{ border: '1px solid var(--border-color)', borderRadius: '8px', overflow: 'hidden' }}>

                        <div style={{ background: 'var(--tab-inactive-bg)', padding: '8px 14px', borderBottom: '1px solid var(--border-color)', fontSize: '11px', fontWeight: 'bold', color: 'var(--text-muted)' }}>

                          Detailed Analysis Report

                        </div>

                        <pre style={{ margin: '0', padding: '14px', background: '#090d16', color: '#e2e8f0', fontSize: '11px', fontFamily: 'var(--font-mono)', overflowX: 'auto', whiteSpace: 'pre-wrap', maxHeight: '400px', overflowY: 'auto' }}>

                          {coverageReportData.raw}

                        </pre>

                      </div>

                    </div>

                  ) : (

                    <div className={styles.toolInfoPane}>

                      <span style={{ fontSize: '28px' }}>🛡️</span>

                      <strong>No Coverage Report Available</strong>

                      <p>Run simulation with code coverage enabled to generate visual scorecards and detailed coverage reports.</p>

                    </div>

                  )

                )}

              </div>



            </div>



          </div>

        </div>

      ) : (

        <CodeProjects

          onRestoreProject={restoreSavedProject}

          onBackToEditor={() => setView('playground')}

        />

      )}



      {showNewFileModal && (

        <div className={styles.modalOverlay}>

          <div className={styles.modal}>

            <div className={`${styles.modalHeader} ${styles.infoModalHeader}`}>

              <h3>New File</h3>

            </div>

            <div className={styles.modalBody}>

              <p style={{ marginBottom: '0.5rem' }}>Enter a name for the new file:</p>

              <input

                autoFocus

                type="text"

                className={styles.tabRenameInput}

                style={{ width: '100%', padding: '0.5rem' }}

                placeholder="e.g., counter.v"

                value={newFileName}

                onChange={(e) => setNewFileName(e.target.value)}

                onKeyDown={(e) => {

                  if (e.key === 'Enter') confirmAddFile();

                  if (e.key === 'Escape') { setShowNewFileModal(false); setNewFileName(''); }

                }}

              />

            </div>

            <div className={styles.modalFooter}>

              <button className={styles.cancelBtn} onClick={() => { setShowNewFileModal(false); setNewFileName(''); }}>Cancel</button>

              <button

                className={styles.confirmDeleteBtn}

                style={{ background: 'var(--primary-color)' }}

                onClick={confirmAddFile}

              >

                Create File

              </button>

            </div>

          </div>

        </div>

      )}



      {showSaveModal && (

        <div className={styles.modalOverlay}>

          <div className={styles.modal}>

            <div className={`${styles.modalHeader} ${styles.infoModalHeader}`}>

              <h3>Save Project</h3>

            </div>

            <div className={styles.modalBody}>

              <p style={{ marginBottom: '0.5rem' }}>Enter a name for this code project:</p>

              <input

                autoFocus

                type="text"

                className={styles.tabRenameInput}

                style={{ width: '100%', padding: '0.5rem' }}

                placeholder="e.g., 4-bit ALU Design"

                value={saveTitle}

                onChange={(e) => setSaveTitle(e.target.value)}

                onKeyDown={(e) => {

                  if (e.key === 'Enter') confirmSaveToBackend();

                  if (e.key === 'Escape') setShowSaveModal(false);

                }}

              />

            </div>

            <div className={styles.modalFooter}>

              <button className={styles.cancelBtn} onClick={() => setShowSaveModal(false)}>Cancel</button>

              <button

                className={styles.confirmDeleteBtn}

                style={{ background: 'var(--primary-color)' }}

                onClick={confirmSaveToBackend}

                disabled={isCurrentlySaving}

              >

                {isCurrentlySaving ? 'Saving...' : 'Confirm Save'}

              </button>

            </div>

          </div>

        </div>

      )}



      {showDeleteModal && (

        <div className={styles.modalOverlay}>

          <div className={styles.modal}>

            <div className={styles.modalHeader}>

              <h3>Confirm Deletion</h3>

            </div>

            <div className={styles.modalBody}>

              Are you sure you want to delete <strong>{fileToDelete?.name}</strong>? This action cannot be undone.

            </div>

            <div className={styles.modalFooter}>

              <button className={styles.cancelBtn} onClick={() => setShowDeleteModal(false)}>Cancel</button>

              <button

                className={styles.confirmDeleteBtn}

                onClick={() => {

                  const remaining = files.filter((f) => f.id !== fileToDelete.id);

                  setFiles(remaining);

                  setOpenTabIds((prev) => prev.filter((id) => id !== fileToDelete.id));

                  

                  if (fileToDelete.id === activeFileId) {

                    const next = remaining[remaining.length - 1];

                    if (next) {

                      setActiveFileId(next.id);

                      setCode(next.content || '');

                    }

                  }

                  setShowDeleteModal(false);

                  setFileToDelete(null);

                }}

              >

                Delete File

              </button>

            </div>

          </div>

        </div>

      )}



      {showInfoModal && (

        <div className={styles.modalOverlay}>

          <div className={styles.modal}>

            <div className={`${styles.modalHeader} ${styles.infoModalHeader}`}>

              <h3>Information</h3>

            </div>

            <div className={styles.modalBody}>

              Minimum one file is necessary in each tab. You cannot delete the last remaining file.

            </div>

            <div className={styles.modalFooter}>

              <button className={styles.confirmDeleteBtn} style={{ background: 'var(--primary-color)' }} onClick={() => setShowInfoModal(false)}>

                Understood

              </button>

            </div>

          </div>

        </div>

      )}

      {showLearnModal && (

        <div className={styles.modalOverlay}>

          <div className={styles.modal}>

            <div className={`${styles.modalHeader} ${styles.infoModalHeader}`}>

              <h3>Moving to Separate Website</h3>

            </div>

            <div className={styles.modalBody}>

              You are about to leave the CodeBox IDE and open the SiliconLogix main website to access the Learning page. Do you wish to proceed?

            </div>

            <div className={styles.modalFooter}>

              <button className={styles.cancelBtn} onClick={() => setShowLearnModal(false)}>Cancel</button>

              <button 

                className={styles.confirmDeleteBtn} 

                style={{ background: 'var(--primary-color)' }}

                onClick={handleProceedLearn}

              >

                Proceed

              </button>

            </div>

          </div>

        </div>

      )}

      {showAuthModal && (

        <AuthModal

          show={showAuthModal}

          onClose={() => setShowAuthModal(false)}

          initialMode={authModalMode}

        />

      )}

    </div>

  );

};



export default CodeTest; 